// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:07:03.439Z
// Property: Fox Ridge and Lakeview Park Apartments (ID: 6767906449166316)
// Collections: 27 amenities, 30 floorplans (live), 34 photos, 85 POIs, 5 reviews, 1 virtual tours, 6 office hours, 3 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166316",
  "property_external_id": "33419",
  "property_zillow_url": "https://www.zillow.com/apartments/limerick-pa/fox-ridge/5c9sgZ/",
  "property_apartments_url": "https://www.apartments.com/fox-ridge-limerick-pa/vb6qh7g/",
  "property_google_business_url": "https://www.google.com/maps/place/Fox+Ridge+and+Lakeview+Park+Apartments/data=!4m2!3m1!1s0x0:0x97f8389ce9c5b4a5?sa=X&ved=2ahUKEwjH0bvNm7iSAxWkrokEHfvMGTUQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "53176767895",
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "fox-ridge-and-lakeview-park-apartments",
  "property_name": "Fox Ridge and Lakeview Park Apartments",
  "property_website_url": "https://www.liveatfoxridge.com/",
  "property_domain": "https://www.liveatfoxridge.com/",
  "property_address": "817 Walden Court",
  "property_full_address": "817 Walden Ct, Limerick, PA 19468",
  "property_address_1": "817 Walden Ct",
  "property_address_2": null,
  "property_address_city": "Limerick",
  "property_address_state": "PA",
  "property_address_zip_full": "19468",
  "property_address_zip": "19468",
  "property_address_country": "US",
  "property_address_county": "Montgomery County",
  "property_neighborhood_address": "Upper Montgomery County",
  "property_address_latitude": "40.2385398",
  "property_address_longitude": "-75.5371723",
  "property_email": "foxridge@aionmanagement.com",
  "property_phone": "(484) 689-3229",
  "property_call_tracking_phone": "215-318-9651",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Fox Ridge Apartments in Limerick, PA, where modern living meets comfort. Choose from spacious one and two-bedroom floor plans, enjoy amenities like a fitness center, tennis court, and full-size washer & dryer. With pet-friendly options and serene pond views, your perfect home awaits! Schedule a tour today!",
  "property_long_description": "Welcome to Fox Ridge Apartments, your ideal sanctuary nestled in the heart of Limerick, PA! Our thoughtfully designed community offers a variety of stylish floor plans, including one and two-bedroom apartments, tailored to fit your lifestyle. Each home is a blend of modern comfort and convenience, featuring luxurious finishes such as stainless steel appliances, vinyl plank flooring, and chic black fixtures. Enjoy the serene views from your private patio or balcony, and unwind by the cozy fireplace after a long day.\n\nAt Fox Ridge, you’ll find a vibrant community atmosphere with plenty of resident activities and a robust online portal for easy rent payments and maintenance requests. We understand the needs of your furry friends, which is why we’re proud to be pet-friendly. Our amenities cater to every lifestyle, offering a state-of-the-art fitness center, on-site laundry, and tennis courts for recreational fun. Need flexibility? Short-term leases are available!\n\nSafety and convenience are paramount; enjoy 24-hour emergency maintenance, on-site management, and ample parking options. With renovated bathrooms, modern white cabinets, and a serene pond view, every detail has been carefully curated to provide upscale living. From our stunning courtyard to full-size washers and dryers in select units, Fox Ridge Apartments ensures a luxurious yet cozy environment.\n\nDon’t miss out on the opportunity to become part of our vibrant community! Find your new home today—browse our availability or schedule a tour to visit Fox Ridge Apartments and experience all the charm and comfort we have to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-7c7b-71a9-ad1d-c358f0e52ab0.webp",
  "property_featured_image_media": {
    "alt_text": "Modern dining area and kitchen with stainless steel appliances and breakfast bar.",
    "public_id": "019fcdf5-7c7b-71a9-ad1d-c358f0e52ab0",
    "storage_key": "property/6767906449166316/019fcdf5-7c7b-71a9-ad1d-c358f0e52ab0.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "176",
  "property_year_built": "1991",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.45454545454545",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions apply.",
  "property_pet_policy_description": "Cats and dogs are welcome. Monthly pet rent is $150 per pet. Maximum of 2 pets per unit. One-time pet fee: $350 per pet. Breed restrictions apply.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://foxridgepa.loftliving.com/login",
  "property_apply_now_url": "https://www.liveatfoxridge.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fa453-42c5-728f-b560-20af6b608dc7.webp",
  "property_primary_logo_media": {
    "alt_text": "Fox Ridge & Lakeview Park logo",
    "public_id": "019fa453-42c5-728f-b560-20af6b608dc7",
    "storage_key": "property/6767906449166316/019fa453-42c5-728f-b560-20af6b608dc7.webp",
    "width": 386,
    "height": 65
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0268-2ee3-708c-b1c3-72a1d462c776.webp",
  "property_secondary_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0268-2ee3-708c-b1c3-72a1d462c776",
    "storage_key": "property/6767906449166316/019d0268-2ee3-708c-b1c3-72a1d462c776.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fa453-786a-748c-bdb2-4a4901979116.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Fox Ridge Apartments logo",
    "public_id": "019fa453-786a-748c-bdb2-4a4901979116",
    "storage_key": "property/6767906449166316/019fa453-786a-748c-bdb2-4a4901979116.webp",
    "width": 386,
    "height": 65
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fa453-6d21-731b-92a4-975fc7eb767c.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Fox Ridge Apartments logo featuring a stylized fox silhouette next to the text 'FOX RIDGE APARTMENTS'.",
    "public_id": "019fa453-6d21-731b-92a4-975fc7eb767c",
    "storage_key": "property/6767906449166316/019fa453-6d21-731b-92a4-975fc7eb767c.webp",
    "width": 386,
    "height": 65
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "863 - 1225",
  "property_sqft_min": "863",
  "property_sqft_max": "1225",
  "property_price_range": "1729 - 2399",
  "property_price_min": "1729",
  "property_price_max": "2399",
  "property_available_units": 8,
  "property_facebook_url": "https://facebook.com/liveatfoxridge/?locale=fa_IR",
  "property_instagram_url": "https://www.instagram.com/liveatfoxridge",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJH2d52i-FxokRpbTF6Zw4-Jc",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?cflt=apartments&find_near=fox-ridge-at-lakeside-limerick",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Fox Ridge Apartments",
  "property_home_romance_title": "Embrace Life in Your Perfect Apartment Home Today",
  "property_home_amenities_blurb": "Welcome to Fox Ridge Apartments in Limerick, PA, where stylish living meets comfort. Our one and two-bedroom floor plans offer modern finishes like stainless steel appliances and chic black fixtures. Enjoy a vibrant community with tennis courts, a fitness center, and pet-friendly designs. Your ideal lifestyle awaits!",
  "property_home_floorplans_blurb": "Welcome to Fox Ridge Apartments in Limerick, PA, where your ideal living space awaits! Choose from our thoughtfully designed one and two-bedroom floor plans, each crafted for comfort and style. Browse our available apartment homes today and embrace a lifestyle of convenience and charm right here at Fox Ridge!",
  "property_home_gallery_blurb": "Welcome to Fox Ridge Apartments in Limerick, PA, where modern living meets comfort. Choose from spacious one and two-bedroom floor plans, enjoy amenities like a fitness center, tennis court, and serene pond views. Make memories with resident activities and relish our pet-friendly community. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Fox Ridge Apartments in Limerick, PA, where your dream home meets vibrant community living! Nestled near parks, schools, and the Greater Philadelphia Expo Center, enjoy convenient access to entertainment and education. Embrace a lifestyle enriched by nearby attractions and top-notch amenities. Your perfect home awaits—come see for yourself!",
  "property_home_reviews_blurb": "At Fox Ridge Apartments in Limerick, PA, residents rave about the exceptional management and welcoming community atmosphere. With professional staff ready to assist, one resident exclaimed, “Things are really looking up!” Experience a beautifully maintained property where thoughtful service elevates the standard of apartment living. See what our residents have to say!",
  "property_neighborhood_blurb": "Nestled in Limerick, PA, Fox Ridge Apartments offers easy access to captivating local attractions. From the serene beauty of Upper Schuylkill Valley Park to the engaging exhibits at the American Treasure Tour Museum, our vibrant neighborhood invites exploration. Uncover the perfect blend of nature, education, and entertainment right at your doorstep.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Fox Ridge Apartments in Limerick, PA, elevate your lifestyle with modern floor plans and exceptional amenities. Enjoy vibrant resident activities, a pet-friendly environment, and fitness facilities. Delight in the serene pond view from your private balcony while relishing stylish interiors equipped with stainless steel appliances. Experience comfort and convenience today!",
  "property_applynow_blurb": "Step into comfort at Fox Ridge Apartments in Limerick, PA. Choose from spacious one and two-bedroom floor plans and enjoy a host of amenities, from a fitness center to serene pond views. With pet-friendly options and flexible leasing, your ideal living space awaits. Lease online today and elevate your lifestyle!",
  "property_contactus_blurb": "At Fox Ridge Apartments in Limerick, PA, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Each space is crafted for comfort and convenience, making it the perfect home. Have questions? Reach out to our leasing team today to learn more about your future residence!",
  "property_faqs_blurb": "At Fox Ridge Apartments in Limerick, PA, we offer a variety of thoughtfully designed floor plans, including spacious one and two-bedroom options. Curious about our community? Dive into our FAQs page to uncover the essential details that make Fox Ridge the perfect place to call home!",
  "property_floorplans_blurb": "At Fox Ridge Apartments in Limerick, PA, choose from our thoughtfully designed one and two-bedroom floor plans tailored to suit your lifestyle. Each spacious layout boasts modern finishes, ensuring comfort and style. Browse our available apartment homes and find the perfect floor plan that fits your unique needs today!",
  "property_gallery_blurb": "At Fox Ridge Apartments in Limerick, PA, vibrant living meets modern comfort. Whether you prefer a cozy one-bedroom or a spacious two-bedroom, our upgraded spaces with stunning pond views, stainless steel appliances, and inviting amenities like a fitness center and tennis court make every day exceptional. Picture yourself living here!",
  "property_interactivemap_blurb": "At Fox Ridge Apartments in Limerick, PA, a dynamic blend of comfort and convenience awaits. Choose from stylish one- or two-bedroom floor plans, each featuring modern finishes, a courtyard, and pet-friendly amenities. With an interactive community map, finding your ideal home has never been easier. Your perfect lifestyle starts here!",
  "property_pets_blurb": "Nestled in Limerick, PA, Fox Ridge Apartments invites you and your furry companions to experience tranquil living. With spacious homes and a pet-friendly policy accommodating up to two pets, you can enjoy life together while creating cherished moments in a vibrant community. Experience comfort and convenience today!",
  "property_referafriend_blurb": "At Fox Ridge Apartments in Limerick, PA, your ideal home awaits! Whether you’re seeking a cozy one-bedroom or a spacious two-bedroom layout, our welcoming community is perfect for sharing life’s moments. Great friends make great neighbors—refer a friend today and enjoy the vibrant lifestyle together!",
  "property_residentaccess_blurb": "At Fox Ridge Apartments in Limerick, PA, tailored living awaits with spacious one and two-bedroom floor plans. Join our vibrant community today and elevate your lifestyle. Access your resident portal effortlessly to pay rent, schedule maintenance, and enjoy seamless living. Your comfortable home journey starts here!",
  "property_reviews_blurb": "At Fox Ridge Apartments in Limerick, PA, our residents rave about the welcoming atmosphere and attentive management. One resident shared, \"The new staff is professional and helpful,\" while another noted, “Things are really looking up”—testament to our commitment to exceptional service and well-maintained living.  See what our residents have to say!",
  "property_created_at": "1757005107350",
  "property_scheduletour_blurb": "At Fox Ridge Apartments in Limerick, PA, we offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Experience the perfect blend of comfort and convenience. Schedule a tour today and see what our residents love most about calling Fox Ridge home!",
  "property_thankyou_blurb": "Thank you for reaching out to Fox Ridge Apartments in Limerick, PA! We’re excited to assist you in finding your perfect home. With captivating one and two-bedroom floor plans, we offer a variety of options to suit your lifestyle. Stay tuned—our team will be in touch shortly!",
  "property_virtualtours_blurb": "At Fox Ridge Apartments in Limerick, PA, you'll find thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Experience comfort and style in every corner. Ready to envision your new home? Take a virtual tour today and explore your future sanctuary!",
  "property_copyright": "2025 All Rights Reserved. Fox Ridge Apartments",
  "property_seo_title_home": "Fox Ridge & Lakeview Park Apartments for Rent | PA",
  "property_seo_description_home": "Discover Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, Pennsylvania. Enjoy spacious apartments, modern amenities, and a convenient location.",
  "property_seo_title_floorplans": "Floor Plans | Apartments near King of Prussia",
  "property_seo_description_floorplans": "Explore floor plans at Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA. Enjoy layouts with balconies, fireplaces, and modern features.",
  "property_seo_title_amenities": "Amenities | Fox Ridge & Lakeview Park Apartments",
  "property_seo_description_amenities": "Explore amenities at Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA. Enjoy a fitness center, dog park, and easy access to Ursinus College.",
  "property_seo_title_gallery": "Gallery | Fox Ridge & Lakeview Park Apartment",
  "property_seo_description_gallery": "Explore the gallery at Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA. See homes and amenities near shopping, dining, and downtown.",
  "property_seo_title_virtualtours": "Virtual Tours | Apts near Philadelphia Premium Outlets",
  "property_seo_description_virtualtours": "Take a virtual tour of Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA. Explore homes near Philadelphia Premium Outlets and scenic trails.",
  "property_seo_title_interactivemap": "Interactive Map | Fox Ridge Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Fox Ridge Apartments in Limerick, PA! Use our map to explore modern amenities. Your new lifestyle awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apts near Norristown Transit Center",
  "property_seo_description_neighborhood": "Explore the neighborhood near Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA. Close to King of Prussia, Ursinus College, and shopping.",
  "property_seo_title_contact": "Contact Us | Fox Ridge & Lakeview Park Apartments",
  "property_seo_description_contact": "Reach out to the Fox Ridge Apartments team in Limerick, PA! Inquire about our one and two-bedroom floor plans—your new home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in Limerick, PA",
  "property_seo_description_faqs": "Find answers to your burning questions at Fox Ridge Apartments in Limerick, PA! Learn about our floor plans, amenities, and community features today.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Limerick, PA",
  "property_seo_description_reviews": "Join the Fox Ridge family in Limerick, PA! Hear our residents' stories and discover a lifestyle filled with modern amenities and vibrant community activities.",
  "property_seo_title_applynow": "Apply Now | Apartments near Philadelphia Airport",
  "property_seo_description_applynow": "Apply online at Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA. Start your application today and secure your new home.",
  "property_seo_title_residentaccess": "Resident Access | Fox Ridge & Lakeview Park Apts",
  "property_seo_description_residentaccess": "Access your resident portal at Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA. Manage payments, requests, and more.",
  "property_seo_title_referafriend": "Refer A Friend | Fox Ridge Apartments",
  "property_seo_description_referafriend": "Refer a friend to Fox Ridge Apartments in Limerick, PA! Share the joy of great living and build a community where wonderful friendships flourish.",
  "property_seo_title_scheduletour": "Schedule a Tour | Apts near Norristown Transit Center",
  "property_seo_description_scheduletour": "Schedule a tour at Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA. Visit our community and find your next home today.",
  "property_seo_title_privacy": "Privacy Policy | Fox Ridge & Lakeview Park Apartments",
  "property_seo_description_privacy": "Read the privacy policy for Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA. Learn how we collect, use, and protect your information.",
  "property_seo_title_accessibility": "Accessibility | Fox Ridge & Lakeview Park Apartments",
  "property_seo_description_accessibility": "Learn about accessibility at Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA. We are committed to an inclusive living experience.",
  "property_seo_title_sitemap": "Sitemap | Fox Ridge & Lakeview Park Apartments",
  "property_seo_description_sitemap": "View the sitemap for Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA. Easily navigate pages and find the information you need.",
  "property_seo_title_thankyou": "Thank You | Fox Ridge & Lakeview Park Apartments",
  "property_seo_description_thankyou": "Thank you for contacting Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA. Our team will be in touch with you soon.",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1791293656110",
  "amenities": [
    {
      "id": "custom_ca0db041-eaa8-4631-98ce-113cef6beef5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c41b705d-fa22-4fa0-9418-c6ae9dd3701b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Conference Room (for resident use)",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5f2b3dc8-2a1c-483d-96e1-043ce0262f69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b7916220-faf7-4e11-8403-fb41c907a344",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69f02043-4655-49e5-aa71-49862c4e3af9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Online Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_30223201-0c20-451d-a841-24b5d5c17790",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f91e6311-9e81-466c-aba9-ebed60cee63d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dcf1cf4b-35db-4fe6-bdbf-674563d43c1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b2f23273-d045-473f-9272-272ba763e252",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Short Term Leases",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69449434-de5b-45ca-bf39-9b9c3115cc91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa6322ba-9a68-45cd-814d-eedfde9a9b62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Breakfast Nook",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cf41bc9d-2afc-4f67-a7bc-a915da8e543c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Ceramic Tile Flooring*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_309edf4b-bf7f-4633-9068-a7b24a8fc59d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fe05eb13-879a-47b1-8275-f2a89167eedc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7348355c-927e-4c38-9f0f-bb61af673514",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Fully Renovated Homes*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b17c037f-0bab-4474-9e83-ed7874195c92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_71c126f1-93e0-4fa9-b766-01db075ef46d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3fa48821-89f6-4d1a-96c7-d6fa23bfcf1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balcony or Patio",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa85999d-b8c4-414a-97e0-33e7edf2740c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_96deeeeb-2e19-4aa9-bb53-b4645e530526",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Plank Flooring*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_be523270-9fb7-4892-a8cb-7d2dc6e79a75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer Included",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b80375c5-34f0-4fb1-af85-c732c74063d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Carports Available",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1d5bdf31-399e-4c20-a42b-7c8389d31b14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_95657ca0-1635-4cab-93ca-7832825372ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Gazebo",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ba6daa92-73be-42ae-96ca-06a5c66d1400",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling Stations/Picnic Area *Coming Soon",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3dafaac5-e391-4563-af7f-62b9dfd7f261",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1da11a9b-dddb-4674-a0f3-63235b402493",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "external_id": "false",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_f6a9d27f-e329-4187-afd9-a8b15bc84035",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-8e4d-71db-835f-1326feb1a6bb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
        "public_id": "019fcdf5-8e4d-71db-835f-1326feb1a6bb",
        "storage_key": "property/6767906449166316/019fcdf5-8e4d-71db-835f-1326feb1a6bb.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright, contemporary kitchen in a modern apartment with white cabinets, stainless steel appliances, and light wood floors.",
      "link": "false",
      "alt_text": "Modern white kitchen with stainless steel refrigerator, oven, microwave, and cabinetry. Visit us at Fox Ridge & Lakeview Park Apartments and view our apartments for rent in Limerick, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/5767906449162442/6767906449166316/91f724a6b576c1c406e0b85658e37280.webp"
    },
    {
      "id": "custom_5665a5f3-b3ae-4ad3-9e05-4b3015c69f11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-8ea3-72f1-a9c9-9da2967cc6d0.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with dining table, sofa, and chairs.",
        "public_id": "019fcdf5-8ea3-72f1-a9c9-9da2967cc6d0",
        "storage_key": "property/6767906449166316/019fcdf5-8ea3-72f1-a9c9-9da2967cc6d0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright, modern apartment featuring white cabinetry, stainless steel appliances, and a large dining table connected to a comfortable living space.",
      "link": "false",
      "alt_text": "Open-concept kitchen with white cabinets and stainless-steel appliances opening to a living area. Visit us at Fox Ridge & Lakeview Park Apartments and view our pet-friendly apartments for rent in Limerick, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/5767906449162442/6767906449166316/4d2f5e4f3b82b17b27f6526456ad7649.webp"
    },
    {
      "id": "custom_7553f4c5-a991-4715-96ec-292c120d1346",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-8e93-714f-8e10-6cb4e7d4a868.webp",
      "image_media": {
        "alt_text": "Living room and dining area of an apartment with modern furniture and stainless steel appliances visible in the kitchen.",
        "public_id": "019fcdf5-8e93-714f-8e10-6cb4e7d4a868",
        "storage_key": "property/6767906449166316/019fcdf5-8e93-714f-8e10-6cb4e7d4a868.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed living and dining area, seamlessly connected to a modern kitchen. Perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Open-concept living room in a modern apartment with gray sofa, coffee table, and dining area. Visit us at Fox Ridge & Lakeview Park Apartments and view our modern, garden-style 1 and 2 bedroom apartments in Limerick, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/5767906449162442/6767906449166316/33e99e9b9f2596d3d87037447f7534f7.webp"
    },
    {
      "id": "custom_bb2e9eec-634f-42c8-b7de-2b2d55912921",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-8e62-71b8-99e3-1390d5363613.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a king-size bed, nightstands, and a closet.",
        "public_id": "019fcdf5-8e62-71b8-99e3-1390d5363613",
        "storage_key": "property/6767906449166316/019fcdf5-8e62-71b8-99e3-1390d5363613.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright, contemporary bedroom in a stylish apartment with neutral tones, wood flooring, and natural light.",
      "link": "false",
      "alt_text": "Modern apartment bedroom with a large bed, two nightstands, and an open closet. Visit us at Fox Ridge & Lakeview Park Apartments and view our modern, garden-style 1 and 2 bedroom apartments in Limerick, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/bca9e75b381ec8bf87a39fc89f943dba-fac305ed.webp"
    },
    {
      "id": "custom_253d1117-39d8-491a-87f8-443ef27815eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-97ed-72c9-a81e-1bb33ab140bf.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and a large island.",
        "public_id": "019fcdf5-97ed-72c9-a81e-1bb33ab140bf",
        "storage_key": "property/6767906449166316/019fcdf5-97ed-72c9-a81e-1bb33ab140bf.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this sleek, modern kitchen featuring stainless steel appliances, ample cabinet space, and a large island perfect for meal prep or casual dining.",
      "link": "false",
      "alt_text": "Bright modern white kitchen with stainless steel appliances and wood flooring",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/54-web-or-mls-817+Walden+Ct+Unit+1102-S0907-014.jpg"
    },
    {
      "id": "custom_027d76d1-a5bc-4fb9-8e63-4e0eb8d719f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-9911-7514-bd5c-50c1fc65d0b3.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and dining area",
        "public_id": "019fcdf5-9911-7514-bd5c-50c1fc65d0b3",
        "storage_key": "property/6767906449166316/019fcdf5-9911-7514-bd5c-50c1fc65d0b3.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a fireplace, comfortable seating, and a separate dining space, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Bright modern living room with white walls, gray sofa, fireplace, and round window overlooking a dining area",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/Property_9F3C_48-web-or-mls-817_Walden_Ct_Unit_1102-S0907-008_15-07-26_16_40.jpeg"
    },
    {
      "id": "custom_654cc064-d907-447c-8708-a6863e4d9ba7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-9de6-76ca-ac23-281945cfd847.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, coffee table, and round window.",
        "public_id": "019fcdf5-9de6-76ca-ac23-281945cfd847",
        "storage_key": "property/6767906449166316/019fcdf5-9de6-76ca-ac23-281945cfd847.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace, comfortable sofa, elegant coffee table, and a unique round window, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Bright living room with gray walls, fireplace, wood floors, and sliding glass doors",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/Property_9F3C_45-web-or-mls-817_Walden_Ct_Unit_1102-S0907-005_15-07-26_16_52.jpeg"
    },
    {
      "id": "custom_ccb6a96f-3bc7-4204-8a19-9c95ffc73805",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-9e2a-75a0-b900-77d2149eaa1c.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and closet.",
        "public_id": "019fcdf5-9e2a-75a0-b900-77d2149eaa1c",
        "storage_key": "property/6767906449166316/019fcdf5-9e2a-75a0-b900-77d2149eaa1c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a plush king-size bed, ample closet space, and a stylish dresser, creating a comfortable and elegant living area.",
      "link": "false",
      "alt_text": "Bright bedroom with patterned bedspread, white dresser, and open doorway to a bathroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/Property_9F3C_69-web-or-mls-817_Walden_Ct_Unit_1102-S0907-029_15-07-26_16_39.jpeg"
    },
    {
      "id": "custom_e451cc99-7bf3-40b4-9740-aaa8ef423fc9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-7c7b-71a9-ad1d-c358f0e52ab0.webp",
      "image_media": {
        "alt_text": "Modern dining area and kitchen with stainless steel appliances and breakfast bar.",
        "public_id": "019fcdf5-7c7b-71a9-ad1d-c358f0e52ab0",
        "storage_key": "property/6767906449166316/019fcdf5-7c7b-71a9-ad1d-c358f0e52ab0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Open-concept living space featuring a dining area with a stylish table and chairs, adjacent to a fully equipped kitchen with a breakfast bar, perfect for entertaining.",
      "link": "false",
      "alt_text": "Bright modern kitchen with white cabinets, stainless fridge, dining table, and light wood floors",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/Property_9F3C_26-web-or-mls-817_Walden_Ct_Unit_905-S0907-008_15-07-26_16_41.jpeg"
    },
    {
      "id": "custom_08b52763-a9af-42ea-a4a0-7ba2aa40b4e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-a350-77dc-8e9a-aafd0b7322d5.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, coffee table, and entryway.",
        "public_id": "019fcdf5-a350-77dc-8e9a-aafd0b7322d5",
        "storage_key": "property/6767906449166316/019fcdf5-a350-77dc-8e9a-aafd0b7322d5.webp",
        "width": 1866,
        "height": 1244
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy fireplace, comfortable seating, and a stylish coffee table, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Bright living room with gray sofa, coffee table, fireplace, and sliding doors to a patio",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/Property_9F3C_22-web-or-mls-817_Walden_Ct_Unit_905-S0907-004_15-07-26_16_57.jpg"
    },
    {
      "id": "custom_4e1fccd0-cb4b-4482-868d-9ba47e638e0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-a5e8-7269-9eae-6400f21660bb.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-sized bed, dresser, and abstract art.",
        "public_id": "019fcdf5-a5e8-7269-9eae-6400f21660bb",
        "storage_key": "property/6767906449166316/019fcdf5-a5e8-7269-9eae-6400f21660bb.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a comfortable king-sized bed, stylish dresser, and elegant abstract wall art.",
      "link": "false",
      "alt_text": "Bright bedroom with a bed, wooden dresser, nightstand, wall art, and window seat by a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/Property_9F3C_36-web-or-mls-817_Walden_Ct_Unit_905-S0907-018_15-07-26_16_12.jpg"
    },
    {
      "id": "custom_7e4eab75-d48a-49c2-a77c-ce47de58c7a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-a9c5-7212-ba82-6a257576c096.webp",
      "image_media": {
        "alt_text": "Washer and dryer in laundry closet.",
        "public_id": "019fcdf5-a9c5-7212-ba82-6a257576c096",
        "storage_key": "property/6767906449166316/019fcdf5-a9c5-7212-ba82-6a257576c096.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience.",
      "link": "false",
      "alt_text": "Laundry nook with side by side washer and dryer in a hallway next to a windowed room",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/35-web-or-mls-817+Walden+Ct+Unit+905-S0907-017.jpg"
    },
    {
      "id": "custom_9a8dd0ab-18da-46fb-9f90-8ff9bd447f36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-a984-717b-88e7-13632bac6d64.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, dual sinks, and a walk-in glass shower.",
        "public_id": "019fcdf5-a984-717b-88e7-13632bac6d64",
        "storage_key": "property/6767906449166316/019fcdf5-a984-717b-88e7-13632bac6d64.webp",
        "width": 1280,
        "height": 888
      },
      "title": "Apartment",
      "description": "Step into luxury with this beautifully appointed bathroom featuring a spacious double vanity, dual sinks, and a sleek, modern walk-in shower. Perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "Modern bathroom with a double vanity, two mirrors, and a glass-enclosed shower. Visit us at Fox Ridge & Lakeview Park Apartments and view our modern, garden-style 1 and 2 bedroom apartments in Limerick, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/5767906449162442/6767906449166316/74afa2c38adb85d3b3fda64e05df0740.webp"
    },
    {
      "id": "custom_a30be315-9745-4be3-b4d6-6fca09591d54",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-add8-728e-a7e4-bbf9ae016d34.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and bathtub. A washer and dryer are visible through an open door.",
        "public_id": "019fcdf5-add8-728e-a7e4-bbf9ae016d34",
        "storage_key": "property/6767906449166316/019fcdf5-add8-728e-a7e4-bbf9ae016d34.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a sleek vanity, a comfortable toilet, and a clean bathtub/shower combination. A convenient in-unit washer and dryer are also included.",
      "link": "false",
      "alt_text": "Modern bathroom with white vanity, black fixtures, mirror, toilet, and in-unit laundry",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/59-web-or-mls-817+Walden+Ct+Unit+1102-S0907-019.jpg"
    },
    {
      "id": "custom_b258984a-b8b4-42bb-b91c-185a11aacdde",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-b202-734d-b586-5966e6103b81.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, refrigerator, stove, microwave, and dishwasher. Wood-look flooring.",
        "public_id": "019fcdf5-b202-734d-b586-5966e6103b81",
        "storage_key": "property/6767906449166316/019fcdf5-b202-734d-b586-5966e6103b81.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright, modern apartment kitchen with white cabinets, coordinating appliances, and wood-style flooring.",
      "link": "false",
      "alt_text": "White kitchen with refrigerator, stove, microwave, dishwasher, and wood-look flooring. Visit us at Fox Ridge & Lakeview Park Apartments and view our apartments for rent in Limerick, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/cfeaa5b9126a7596111e8b368603bfc5-3fe6228d.webp"
    },
    {
      "id": "custom_66f48979-45e1-4b70-8f39-36f60d3e61fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-b452-7014-be40-9b25650cf5ae.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, fireplace, and sliding glass doors.",
        "public_id": "019fcdf5-b452-7014-be40-9b25650cf5ae",
        "storage_key": "property/6767906449166316/019fcdf5-b452-7014-be40-9b25650cf5ae.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional sofa, a cozy fireplace, and large sliding glass doors that open to an outdoor space.",
      "link": "false",
      "alt_text": "Spacious modern apartment living room with gray sectional, two chairs, fireplace, and sliding glass door. Visit us at Fox Ridge & Lakeview Park Apartments and view our apartments for rent in Limerick, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/5767906449162442/6767906449166316/3143eb561a5b926dc8379e221cbfb0a2.jpg"
    },
    {
      "id": "custom_64116a98-8328-4753-a56c-caae32936ae0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-b63b-7519-8f54-66a6baff7744.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and balcony access.",
        "public_id": "019fcdf5-b63b-7519-8f54-66a6baff7744",
        "storage_key": "property/6767906449166316/019fcdf5-b63b-7519-8f54-66a6baff7744.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious apartment living area featuring a fireplace, mounted TV, and balcony access.",
      "link": "false",
      "alt_text": "Bright living room with a fireplace, wall-mounted TV, and balcony door. Visit us at Fox Ridge & Lakeview Park Apartments and view our pet-friendly apartments for rent in Limerick, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/5767906449162442/6767906449166316/f7ec50fd2cc06b647107072bde01f018.jpg"
    },
    {
      "id": "custom_35915b0f-a349-4de8-8011-81cfa881fbde",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-b881-70d9-aad0-f810987dcde3.webp",
      "image_media": {
        "alt_text": "A bedroom with a king-size bed, nightstand, and dresser.",
        "public_id": "019fcdf5-b881-70d9-aad0-f810987dcde3",
        "storage_key": "property/6767906449166316/019fcdf5-b881-70d9-aad0-f810987dcde3.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed with plush bedding, a stylish nightstand, and a dresser. Neutral tones and modern decor create a serene atmosphere.",
      "link": "false",
      "alt_text": "Modern bedroom in an apartment with a large bed, two nightstands, and neutral decor. Visit us at Fox Ridge & Lakeview Park Apartments and view our modern, garden-style 1 and 2 bedroom apartments in Limerick, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/5767906449162442/6767906449166316/d9fea81378e0ec42df2c451b0f5e2986.webp"
    },
    {
      "id": "custom_2a1ad627-63c2-4e8e-a18f-7d2dd67abaac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-be5a-703b-bdfa-dea1276c3aae.webp",
      "image_media": {
        "alt_text": "Modern office space with a desk, chair, and bookshelf.",
        "public_id": "019fcdf5-be5a-703b-bdfa-dea1276c3aae",
        "storage_key": "property/6767906449166316/019fcdf5-be5a-703b-bdfa-dea1276c3aae.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Contemporary apartment interior with a spacious home office, dark wood desk, and industrial-style shelving.",
      "link": "false",
      "alt_text": "Modern apartment home office with wooden desk, metal shelving, and an open door to a hallway. Visit us at Fox Ridge & Lakeview Park Apartments and view our pet-friendly apartments for rent in Limerick, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/5767906449162442/6767906449166316/8bee93bcdbec6c50f6213b158214aef9.webp"
    },
    {
      "id": "custom_a1958ad1-2502-4389-9305-bd4044fe9f03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-c0f0-73c9-ad2f-8a826f1150ff.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, white countertops, stove, microwave, and refrigerator.",
        "public_id": "019fcdf5-c0f0-73c9-ad2f-8a826f1150ff",
        "storage_key": "property/6767906449166316/019fcdf5-c0f0-73c9-ad2f-8a826f1150ff.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with full-size white appliances, abundant wood cabinets, and ample counter space.",
      "link": "false",
      "alt_text": "Bright kitchen in an apartment with wood cabinets, white refrigerator, stove, microwave, and sink. Visit us at Fox Ridge & Lakeview Park Apartments and view our pet-friendly apartments for rent in Limerick, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/5767906449162442/6767906449166316/e1995e98913e002ede1c721dfeb76d9f.webp"
    },
    {
      "id": "custom_f443a2fd-a957-4a8d-a06b-f2658cde6a2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-c2bf-7524-82ff-50dfa770d3ca.webp",
      "image_media": {
        "alt_text": "Spacious living room with sliding glass doors, sofa, coffee table, and accent chairs.",
        "public_id": "019fcdf5-c2bf-7524-82ff-50dfa770d3ca",
        "storage_key": "property/6767906449166316/019fcdf5-c2bf-7524-82ff-50dfa770d3ca.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living room in an apartment with modern furnishings, a wall art piece, and balcony access.",
      "link": "false",
      "alt_text": "Bright living room in an apartment with a gray sofa, glass coffee table, and sliding balcony doors. Visit us at Fox Ridge & Lakeview Park Apartments and view our modern, garden-style 1 and 2-bedroom apartments in Limerick, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/5767906449162442/6767906449166316/ae9ce1a2d1195750fff54acabe21b588.webp"
    },
    {
      "id": "custom_2e982c8b-b215-41e9-99bd-f03e15ee321b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-ce68-7619-8041-881837fef73e.webp",
      "image_media": {
        "alt_text": "Treadmills, elliptical, and weight machine in a fitness center with blue walls and arched windows.",
        "public_id": "019fcdf5-ce68-7619-8041-881837fef73e",
        "storage_key": "property/6767906449166316/019fcdf5-ce68-7619-8041-881837fef73e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center, featuring treadmills, an elliptical, and a cable crossover machine. Enjoy your workout with a view of the outdoors through our large, arched windows.",
      "link": "false",
      "alt_text": "Bright blue gym with treadmills, elliptical, and strength machines in a modern workout room",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/4-web-or-mls-Walden+Ct-0907-904.jpg"
    },
    {
      "id": "custom_313d1ca6-e0dc-4fa1-b426-11a6baf581a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-d313-77bf-9cb8-afb5714abd26.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical, stationary bike, weight rack, and TV.",
        "public_id": "019fcdf5-d313-77bf-9cb8-afb5714abd26",
        "storage_key": "property/6767906449166316/019fcdf5-d313-77bf-9cb8-afb5714abd26.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines and free weights.",
      "link": "false",
      "alt_text": "Bright blue gym with treadmills, dumbbells, and workout bench under a vaulted ceiling",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/5-web-or-mls-Walden+Ct-0907-905.jpg"
    },
    {
      "id": "custom_af7e33e7-848a-40eb-b86a-d5d003d9fb5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-ddc2-71dd-ac86-3365be7b83e6.webp",
      "image_media": {
        "alt_text": "Covered parking spaces with cars parked in them on a sunny day.",
        "public_id": "019fcdf5-ddc2-71dd-ac86-3365be7b83e6",
        "storage_key": "property/6767906449166316/019fcdf5-ddc2-71dd-ac86-3365be7b83e6.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Protect your vehicle from the elements with convenient covered parking available at our community.",
      "link": "false",
      "alt_text": "Covered parking area beside a brick building with trees and a paved road under a blue sky",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/75-web-or-mls-817+Walden+Ct+Unit+1102-S0907-035.jpg"
    },
    {
      "id": "custom_69f5848f-cf8f-49a6-a8fe-fe31679461f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-e08a-739f-bf8c-20a29bcd65de.webp",
      "image_media": {
        "alt_text": "Fenced dog park with green grass and trees.",
        "public_id": "019fcdf5-e08a-739f-bf8c-20a29bcd65de",
        "storage_key": "property/6767906449166316/019fcdf5-e08a-739f-bf8c-20a29bcd65de.webp",
        "width": 1868,
        "height": 1245
      },
      "title": "Community",
      "description": "Enjoy our spacious and secure dog park, perfect for your furry friends to play and socialize in a safe, green environment.",
      "link": "false",
      "alt_text": "Chain-link fence enclosing a grassy dog park with trees under a blue sky with clouds",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/10-web-or-mls-Walden+Ct-0907-910.jpg"
    },
    {
      "id": "custom_3373dde4-26ac-48b3-b3bb-2b69353b9391",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-e998-72ca-a403-dbdcd648c048.webp",
      "image_media": {
        "alt_text": "Covered picnic area with grills and picnic tables.",
        "public_id": "019fcdf5-e998-72ca-a403-dbdcd648c048",
        "storage_key": "property/6767906449166316/019fcdf5-e998-72ca-a403-dbdcd648c048.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and gatherings in our community's covered picnic area, complete with grills and seating for all your needs.",
      "link": "false",
      "alt_text": "Covered picnic area with grills and picnic tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/17-web-or-mls-Walden-Ct-0907-917_edit.jpg"
    },
    {
      "id": "custom_e27dd2a4-1d1f-46b1-a578-73967bac9ec5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-ecca-758e-9e13-a2203bb69b49.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and picnic tables.",
        "public_id": "019fcdf5-ecca-758e-9e13-a2203bb69b49",
        "storage_key": "property/6767906449166316/019fcdf5-ecca-758e-9e13-a2203bb69b49.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with our community's grilling stations, complete with ample seating and picnic tables.",
      "link": "false",
      "alt_text": "picnic area with metal tables, grills, and trees on a sunny day",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/8-web-or-mls-Walden+Ct-0907-908.jpg"
    },
    {
      "id": "custom_7a58aefb-9f2a-4e37-b348-ae57c5176625",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-eec6-73de-9356-f92957ad28eb.webp",
      "image_media": {
        "alt_text": "Playground with swings and slides",
        "public_id": "019fcdf5-eec6-73de-9356-f92957ad28eb",
        "storage_key": "property/6767906449166316/019fcdf5-eec6-73de-9356-f92957ad28eb.webp",
        "width": 1482,
        "height": 988
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring a colorful slide set and swings for children.",
      "link": "false",
      "alt_text": "Blue playground slide and climbing structure in a gravel play area with trees and a wooden fence.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/14-web-or-mls-Walden-Ct-0907-914_edit.jpg"
    },
    {
      "id": "custom_52964143-414b-4728-841c-e14d6cf8663a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-ee26-7159-bef9-cff281a393a0.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a playground and gazebo.",
        "public_id": "019fcdf5-ee26-7159-bef9-cff281a393a0",
        "storage_key": "property/6767906449166316/019fcdf5-ee26-7159-bef9-cff281a393a0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our community playground and shaded gazebo, perfect for family fun and relaxation.",
      "link": "false",
      "alt_text": "Apartment complex with brick buildings, green lawn, and a playground under a bright blue sky",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/16-web-or-mls-Walden-Ct-0907-916_edit.jpg"
    },
    {
      "id": "custom_f13e9817-45b9-44c5-8a41-dfdd4ccf6d10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-f80d-7758-b63f-eb8704cab7b0.webp",
      "image_media": {
        "alt_text": "Wooden gazebo with seating area surrounded by lush greenery and trees.",
        "public_id": "019fcdf5-f80d-7758-b63f-eb8704cab7b0",
        "storage_key": "property/6767906449166316/019fcdf5-f80d-7758-b63f-eb8704cab7b0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy the outdoors in this charming wooden gazebo, a perfect spot for relaxation amidst beautiful landscaping.",
      "link": "false",
      "alt_text": "Wooden gazebo in a landscaped garden area of a residential community. Visit us at Fox Ridge & Lakeview Park Apartments and view our modern, garden-style 1 and 2 bedroom apartments in Limerick, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/5767906449162442/6767906449166316/a9790a73604650517396890214e82044.jpg"
    },
    {
      "id": "custom_3ee9b8fc-d4de-4734-b888-0a9e85dc61e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-f9e0-73dd-bc4d-fa203dbdc33a.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with parking lot and handicapped parking spaces.",
        "public_id": "019fcdf5-f9e0-73dd-bc4d-fa203dbdc33a",
        "storage_key": "property/6767906449166316/019fcdf5-f9e0-73dd-bc4d-fa203dbdc33a.webp",
        "width": 1812,
        "height": 1208
      },
      "title": "Community",
      "description": "Exterior view of the apartment building complex, featuring ample parking and accessibility options.",
      "link": "false",
      "alt_text": "Apartment building with brick and white siding, balconies, and empty accessible parking spaces in front",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/42-web-or-mls-817+Walden+Ct+Unit+1102-S0907-002.jpg"
    },
    {
      "id": "custom_2cea5811-7fde-426b-bc58-df627f1d1aab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-faf3-703a-a159-7b288eae7ae1.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with brick and siding, balconies, and green lawns.",
        "public_id": "019fcdf5-faf3-703a-a159-7b288eae7ae1",
        "storage_key": "property/6767906449166316/019fcdf5-faf3-703a-a159-7b288eae7ae1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings featuring a mix of brick and siding, private balconies, and lush green surroundings.",
      "link": "false",
      "alt_text": "Exterior view of a brick and beige siding apartment building with lawns and sidewalks. Visit us at Fox Ridge Apartments and view our modern, garden-style 1 and 2 bedroom apartments in Limerick and Royersford, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/5767906449162442/6767906449166316/2e29146f9b9e0d4069447d8479c97137.webp"
    },
    {
      "id": "custom_83afa10d-e68e-4544-aad9-aa2c33f379d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf5-fb79-72a3-9fd9-72b729b14b75.webp",
      "image_media": {
        "alt_text": "Fox Ridge Apartments monument sign with landscaping and blue sky.",
        "public_id": "019fcdf5-fb79-72a3-9fd9-72b729b14b75",
        "storage_key": "property/6767906449166316/019fcdf5-fb79-72a3-9fd9-72b729b14b75.webp",
        "width": 1730,
        "height": 1153
      },
      "title": "Community",
      "description": "Welcome to Fox Ridge Apartments, a beautiful community with lush landscaping and a prominent monument sign. Contact us at 484.689.3229 or visit liveatfoxridge.com.",
      "link": "false",
      "alt_text": "Outdoor sign at a landscaped entrance with flowers, trees, and a blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/78-web-or-mls-817+Walden+Ct+Unit+1102-S0907-038.jpg"
    },
    {
      "id": "custom_f3272473-5e87-4e7d-9e4b-d7879e1a547e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-0a2a-73ac-bb5c-1cfc4a1bda43.webp",
      "image_media": {
        "alt_text": "Building exterior with address 817, parking spaces, and a golf cart.",
        "public_id": "019fcdf6-0a2a-73ac-bb5c-1cfc4a1bda43",
        "storage_key": "property/6767906449166316/019fcdf6-0a2a-73ac-bb5c-1cfc4a1bda43.webp",
        "width": 1811,
        "height": 1207
      },
      "title": "Community",
      "description": "Exterior of the building, showcasing the property's address, parking amenities, and a golf cart, blending seamlessly with the surrounding landscape.",
      "link": "false",
      "alt_text": "Brick office building with blue door, parking spaces, and a golf cart outside under a bright sky",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8d59708e/dms3rep/multi/1-web-or-mls-Walden+Ct-0907-901.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f6a8574a-4601-454a-ab0f-de5d7d63d6a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Copperfield Inn at Lakeside",
      "poi_type": "Restaurants",
      "poi_address": "594 W Ridge Pike, Limerick, PA 19468, USA",
      "poi_short_description": "Elegant, romantic American restaurant with some Italian dishes, banquet facilities & Sunday brunch.",
      "poi_long_description": "Elegant, romantic American restaurant with some Italian dishes, banquet facilities & Sunday brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-4fb0-748e-990b-4e1e00395c24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-4fb0-748e-990b-4e1e00395c24",
        "storage_key": "property/6767906449166316/019fcdf6-4fb0-748e-990b-4e1e00395c24.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.copperfieldinn.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10143333570214642074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "copperfield-inn-at-lakeside",
      "poi_latitude": "40.2382216",
      "poi_longitude": "-75.5379662",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 484-938-7082",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1d30-730d-af0d-a5b583c0272a",
        "storage_key": "property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8kmIDCFxokRmkHw8iNcxIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c08122a9-1129-458a-b5e2-fd3ea72b91a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Corropolese Italian Bakery & Deli",
      "poi_type": "Restaurants",
      "poi_address": "29 Kugler Rd, Royersford, PA 19468, USA",
      "poi_short_description": "Family-owned bakery with homemade bread, tomato pie & pastries, plus custom cakes & more.",
      "poi_long_description": "Family-owned bakery with homemade bread, tomato pie & pastries, plus custom cakes & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-4fc2-7238-8c3d-503e8f662c25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-4fc2-7238-8c3d-503e8f662c25",
        "storage_key": "property/6767906449166316/019fcdf6-4fc2-7238-8c3d-503e8f662c25.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.corropolesebakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2443190059610382050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corropolese-italian-bakery--deli",
      "poi_latitude": "40.2378655",
      "poi_longitude": "-75.5358704",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-495-8331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1d30-730d-af0d-a5b583c0272a",
        "storage_key": "property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTywvLTCFxokR4p7XJWr05yE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_543da971-f3fc-486e-9a4c-457700da6364",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Ming Garden",
      "poi_type": "Restaurants",
      "poi_address": "15 Kugler Rd, Limerick, PA 19468, USA",
      "poi_short_description": "Casual Chinese eatery offering familiar comfort food such as chicken teriyaki and wonton soup.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-4fc7-7186-9097-18300b2c4773.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-4fc7-7186-9097-18300b2c4773",
        "storage_key": "property/6767906449166316/019fcdf6-4fc7-7186-9097-18300b2c4773.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://minggardenpa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3639076190917825818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ming-garden",
      "poi_latitude": "40.238164",
      "poi_longitude": "-75.53636",
      "poi_miles_from_property": "413 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-495-8201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1d30-730d-af0d-a5b583c0272a",
        "storage_key": "property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCc1yLTCFxokRGhU91oOYgDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a7904876-c123-4d92-a861-db4920d65a7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Tang's Garden",
      "poi_type": "Restaurants",
      "poi_address": "196 W Ridge Pike Unit 178, Royersford, PA 19468, USA",
      "poi_short_description": "Informal restaurant serving generous portions of familiar Chinese dishes for lunch and dinner.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-50ad-71fe-9bb9-5f537338c39f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-50ad-71fe-9bb9-5f537338c39f",
        "storage_key": "property/6767906449166316/019fcdf6-50ad-71fe-9bb9-5f537338c39f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.tangsgardenpa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2384832047065005954&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tangs-garden",
      "poi_latitude": "40.2248792",
      "poi_longitude": "-75.5141214",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-489-5141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1d30-730d-af0d-a5b583c0272a",
        "storage_key": "property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIyrMDbiaxokRgv9GhhygGCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_19616591-a811-4b9d-8eef-7f494efcbdad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Red Top Pizza By Penny's",
      "poi_type": "Restaurants",
      "poi_address": "68 W Ridge Pike, Royersford, PA 19468, USA",
      "poi_short_description": "Thin, crispy pies with cornmeal-dusted crusts served in an informal, hidden pizza speakeasy.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-55b8-7272-b18a-958ce9ef69b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-55b8-7272-b18a-958ce9ef69b2",
        "storage_key": "property/6767906449166316/019fcdf6-55b8-7272-b18a-958ce9ef69b2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2047225138021747369&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-top-pizza-by-pennys",
      "poi_latitude": "40.218069",
      "poi_longitude": "-75.5044784",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 610-489-3636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1d30-730d-af0d-a5b583c0272a",
        "storage_key": "property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9WykB5aaxokRqUoJl2o0aRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1e545687-b41f-49b6-9f62-bf4d2f9bf0f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Main Street Cafe",
      "poi_type": "Restaurants",
      "poi_address": "263 Main St, Royersford, PA 19468, USA",
      "poi_short_description": "Down-to-earth cafe preparing traditional breakfast staples plus burgers and lunch fare, with specials.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-55fb-70ca-b00a-e05973cfbf38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-55fb-70ca-b00a-e05973cfbf38",
        "storage_key": "property/6767906449166316/019fcdf6-55fb-70ca-b00a-e05973cfbf38.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://mainstreetcaferoyersford.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3076898199567313681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-street-cafe",
      "poi_latitude": "40.184177",
      "poi_longitude": "-75.54072699999999",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 610-948-4305",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1e03-728b-8434-ed96875ace79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1e03-728b-8434-ed96875ace79",
        "storage_key": "property/6767906449166316/019d0266-1e03-728b-8434-ed96875ace79.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJwy0cQ8OPxokREas_Q5xWsyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_11a9defe-f873-4ed7-863e-7d76302fa335",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Downtown Gastropub & Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "401 Main St, Royersford, PA 19468, USA",
      "poi_short_description": "Comfort food and a variety of brews offered in a casual space with live music.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-5731-7412-a7ce-1c4fd94e267f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-5731-7412-a7ce-1c4fd94e267f",
        "storage_key": "property/6767906449166316/019fcdf6-5731-7412-a7ce-1c4fd94e267f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://letseatdowntown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6498123264979887548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-gastropub--restaurant",
      "poi_latitude": "40.1853829",
      "poi_longitude": "-75.5390943",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 484-369-8431",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1d30-730d-af0d-a5b583c0272a",
        "storage_key": "property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnYeta6CPxokRvOXTU674LVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_97ad4edb-7fc1-4ddb-8186-408da3c4065a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Giovanni's & Sons Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "466 Main St, Royersford, PA 19468, USA",
      "poi_short_description": "Casual spot with pies & Italian eats, including gluten-free options, with large TVs.",
      "poi_long_description": "Casual spot with pies & Italian eats, including gluten-free options, with large TVs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-5793-7764-ba2c-1c35945c2312.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-5793-7764-ba2c-1c35945c2312",
        "storage_key": "property/6767906449166316/019fcdf6-5793-7764-ba2c-1c35945c2312.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pizzagio.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12359841656873909295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giovannis--sons-pizzeria",
      "poi_latitude": "40.1862831",
      "poi_longitude": "-75.5375442",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 610-948-3693",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1d30-730d-af0d-a5b583c0272a",
        "storage_key": "property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM-XnF92PxokRL3wLboD6hqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ad3c974b-aa95-4020-a036-d20c3de9f19f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Tom's Bar & Grille",
      "poi_type": "Restaurants",
      "poi_address": "772 Walnut St, Royersford, PA 19468, USA",
      "poi_short_description": "Local dive bar and grill offering comfort food and happy hour specials.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-5ce1-731c-9027-a14998ec455d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-5ce1-731c-9027-a14998ec455d",
        "storage_key": "property/6767906449166316/019fcdf6-5ce1-731c-9027-a14998ec455d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tomsbargrille.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8685920217431120315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toms-bar--grille",
      "poi_latitude": "40.189596",
      "poi_longitude": "-75.5312474",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 610-948-0809",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1ccc-74c8-bbf4-efa4f84069a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1ccc-74c8-bbf4-efa4f84069a9",
        "storage_key": "property/6767906449166316/019d0266-1ccc-74c8-bbf4-efa4f84069a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEbUI4-CPxokRu5ld82qWing",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a7e5ea13-0e43-4642-9e3d-d8da96efa573",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Brewed Awakening",
      "poi_type": "Restaurants",
      "poi_address": "306 Main St, Royersford, PA 19468, USA",
      "poi_short_description": "Cozy hangout offering breakfast sandwiches, coffees, and desserts, plus live music.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-5cd7-74ea-83fc-0d1bbd46c3a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-5cd7-74ea-83fc-0d1bbd46c3a3",
        "storage_key": "property/6767906449166316/019fcdf6-5cd7-74ea-83fc-0d1bbd46c3a3.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://www.brewedawakeningcoffeeshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4377537782737742040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brewed-awakening",
      "poi_latitude": "40.18390170000001",
      "poi_longitude": "-75.5405215",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 484-791-3728",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1e03-728b-8434-ed96875ace79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1e03-728b-8434-ed96875ace79",
        "storage_key": "property/6767906449166316/019d0266-1e03-728b-8434-ed96875ace79.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJUxcNXcOPxokR2CjvkmsjwDw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_73f21fa1-d639-4d6d-9bc9-9640ad5a74b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Handel's Homemade Ice Cream",
      "poi_type": "Restaurants",
      "poi_address": "627 Main St, Royersford, PA 19468, USA",
      "poi_short_description": "Long-standing ice cream parlor offering many flavors of ice cream & sorbet, plus sundaes & shakes.",
      "poi_long_description": "Long-standing ice cream parlor offering many flavors of ice cream & sorbet, plus sundaes & shakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-5d6c-75d9-bb2b-9a981691ea31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-5d6c-75d9-bb2b-9a981691ea31",
        "storage_key": "property/6767906449166316/019fcdf6-5d6c-75d9-bb2b-9a981691ea31.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://handelsicecream.com/royersford",
      "poi_directions_map_url": "https://maps.google.com/?cid=15613500369505311449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "handels-homemade-ice-cream",
      "poi_latitude": "40.18889069999999",
      "poi_longitude": "-75.5354262",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 610-492-2908",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1d30-730d-af0d-a5b583c0272a",
        "storage_key": "property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD2OcNOePxokR2VrLuNxLrtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_627d3969-a063-4799-a429-17f9f0ad861b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Annamarie's Place",
      "poi_type": "Restaurants",
      "poi_address": "347 Main St, Royersford, PA 19468, USA",
      "poi_short_description": "Bustling, unfussy eatery dishing out hearty American breakfast & lunch specialties.",
      "poi_long_description": "Bustling, unfussy eatery dishing out hearty American breakfast & lunch specialties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-5dad-74fe-b82d-f761ba905c4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-5dad-74fe-b82d-f761ba905c4b",
        "storage_key": "property/6767906449166316/019fcdf6-5dad-74fe-b82d-f761ba905c4b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.annamariesrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9670185769389510955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "annamaries-place",
      "poi_latitude": "40.1852369",
      "poi_longitude": "-75.5393062",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 610-948-0590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1d30-730d-af0d-a5b583c0272a",
        "storage_key": "property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjXnD0tyPxokRK9F_8LhmM4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7d731523-e605-4f09-9ac8-f2043e679eba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Lost Planet Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "301 Walnut St, Royersford, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-636c-71ec-aae9-526f2518bc49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-636c-71ec-aae9-526f2518bc49",
        "storage_key": "property/6767906449166316/019fcdf6-636c-71ec-aae9-526f2518bc49.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lostplanetbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2216134073034985889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lost-planet-brewing-company",
      "poi_latitude": "40.1832284",
      "poi_longitude": "-75.5398273",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 610-854-8351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa7u6zoqPxokRodHjpTJKwR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4dc3f7f5-2adf-42bb-a94d-4f7b2dd4f9f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Java's Brewin'",
      "poi_type": "Restaurants",
      "poi_address": "296 W Ridge Pike, Royersford, PA 19468, USA",
      "poi_short_description": "Coffee and tea shop serving homemade muffins as well as breakfast sandwiches and coffee smoothies.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-645e-7514-bcef-e1e2d987c2e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-645e-7514-bcef-e1e2d987c2e8",
        "storage_key": "property/6767906449166316/019fcdf6-645e-7514-bcef-e1e2d987c2e8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.javasbrewinlimerick.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10512271092224662808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "javas-brewin",
      "poi_latitude": "40.2288386",
      "poi_longitude": "-75.5178662",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 610-489-3468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1e03-728b-8434-ed96875ace79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1e03-728b-8434-ed96875ace79",
        "storage_key": "property/6767906449166316/019d0266-1e03-728b-8434-ed96875ace79.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ3Zjr7MiaxokRGJ2oqtwW45E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b605fe7c-b70f-4630-8435-7c8c70e28b87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Sunshine Café",
      "poi_type": "Restaurants",
      "poi_address": "207 W Ridge Pike, Royersford, PA 19468, USA",
      "poi_short_description": "Hearty diner-style eatery serving breakfast staples like omelets and pancakes alongside hot tea, sandwiches and burgers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-64e7-764a-b7bb-dc10e96d5e0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-64e7-764a-b7bb-dc10e96d5e0e",
        "storage_key": "property/6767906449166316/019fcdf6-64e7-764a-b7bb-dc10e96d5e0e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.facebook.com/sunshinecafelimerick/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8799427304078342403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunshine-caf",
      "poi_latitude": "40.2240862",
      "poi_longitude": "-75.514704",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-409-8420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1d30-730d-af0d-a5b583c0272a",
        "storage_key": "property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKdu9ELiaxokRA3l2_oLYHXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e4fb289a-c9e6-4fac-a984-7bd99b13bfeb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "GIANT",
      "poi_type": "Shopping",
      "poi_address": "1824 E Ridge Pike, Linfield, PA 19468, USA",
      "poi_short_description": "Grocery store selling produce, meat, and household items, plus passport photos.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-6441-733a-9e66-e89a142fb11b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-6441-733a-9e66-e89a142fb11b",
        "storage_key": "property/6767906449166316/019fcdf6-6441-733a-9e66-e89a142fb11b.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://stores.giantfoodstores.com/pa/royersford/1824-ridge-pike",
      "poi_directions_map_url": "https://maps.google.com/?cid=7918488636176019111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giant",
      "poi_latitude": "40.211579",
      "poi_longitude": "-75.4989028",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 610-831-5450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-21e0-716c-9b54-fde08fc3ad4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21e0-716c-9b54-fde08fc3ad4a",
        "storage_key": "property/6767906449166316/019d0266-21e0-716c-9b54-fde08fc3ad4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ45EYkpmaxokRpy497XUf5G0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_667b44fd-c83d-4247-b731-3a560486b655",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping",
      "poi_address": "33 W Ridge Pike Suite 407, Limerick, PA 19468, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-6a65-747f-b39b-3383442d0cd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-6a65-747f-b39b-3383442d0cd7",
        "storage_key": "property/6767906449166316/019fcdf6-6a65-747f-b39b-3383442d0cd7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.aldi.us/pa/limerick/33-w-ridge-pike?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=9563610424273950726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "40.215239",
      "poi_longitude": "-75.50268009999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-21e0-716c-9b54-fde08fc3ad4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21e0-716c-9b54-fde08fc3ad4a",
        "storage_key": "property/6767906449166316/019d0266-21e0-716c-9b54-fde08fc3ad4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_WvvmZeaxokRBlgSvQLFuIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2dc8c1c7-9a12-4362-b032-ddffa5d9c084",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Lidl",
      "poi_type": "Shopping",
      "poi_address": "1831 E Ridge Pike, Royersford, PA 19468, USA",
      "poi_short_description": "Grocery chain offering fresh produce and baked goods as well as brand-name items and hard-to-find specialities.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-6b28-768d-b957-60aac69f4e1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-6b28-768d-b957-60aac69f4e1f",
        "storage_key": "property/6767906449166316/019fcdf6-6b28-768d-b957-60aac69f4e1f.webp",
        "width": 1280,
        "height": 731
      },
      "poi_business_url": "https://www.lidl.com/stores/US01138",
      "poi_directions_map_url": "https://maps.google.com/?cid=2960144785694227505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lidl",
      "poi_latitude": "40.2135721",
      "poi_longitude": "-75.49608789999999",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 888-654-3515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-21e0-716c-9b54-fde08fc3ad4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21e0-716c-9b54-fde08fc3ad4a",
        "storage_key": "property/6767906449166316/019d0266-21e0-716c-9b54-fde08fc3ad4a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLbo-eeebxokRMXwHw_-LFCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9056dbf0-e2e6-41fc-b8b2-156b66a22b98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping",
      "poi_address": "5 Kugler Rd BUILDING 100, Limerick, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-6a80-710b-94ca-33fbfeb75dd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-6a80-710b-94ca-33fbfeb75dd6",
        "storage_key": "property/6767906449166316/019fcdf6-6a80-710b-94ca-33fbfeb75dd6.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/limerick-pa-pharmacies/5-kugler-road-building-100-limerick-pa-19468/storeid=2690?WT.mc_id=LS_GOOGLE_RX_2690",
      "poi_directions_map_url": "https://maps.google.com/?cid=850569999789779189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.2378033",
      "poi_longitude": "-75.5370865",
      "poi_miles_from_property": "459 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-495-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-21e1-73b9-8260-7ff5e213e20d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21e1-73b9-8260-7ff5e213e20d",
        "storage_key": "property/6767906449166316/019d0266-21e1-73b9-8260-7ff5e213e20d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2-u6KDCFxokR9egShujUzQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f337543e-4a2a-4442-b213-16f40d8af24c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping",
      "poi_address": "30 W Ridge Pike, Limerick, PA 19468, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-6b91-701f-82b5-4713c6e394f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-6b91-701f-82b5-4713c6e394f9",
        "storage_key": "property/6767906449166316/019fcdf6-6b91-701f-82b5-4713c6e394f9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-30+w+ridge+pike-limerick-pa-19468/id=10958",
      "poi_directions_map_url": "https://maps.google.com/?cid=7660796095119188679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "40.216548",
      "poi_longitude": "-75.5009882",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 610-454-7295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq5qjU5aaxokRx2JHunWdUGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_73259260-a9df-4a89-b3a5-89f70a3e9c8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping",
      "poi_address": "1824 E Ridge Pike, Royersford, PA 19468, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-70cc-7029-adc8-d8c1b4b8a0d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-70cc-7029-adc8-d8c1b4b8a0d8",
        "storage_key": "property/6767906449166316/019fcdf6-70cc-7029-adc8-d8c1b4b8a0d8.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/royersford/2131",
      "poi_directions_map_url": "https://maps.google.com/?cid=6700071056477056628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "40.2107675",
      "poi_longitude": "-75.4983701",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 610-226-2151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-221f-72a2-aca1-5419dbbbccf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-221f-72a2-aca1-5419dbbbccf5",
        "storage_key": "property/6767906449166316/019d0266-221f-72a2-aca1-5419dbbbccf5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJt_hFeJqaxokRdO4wmyBv-1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c41c18c9-a713-4ff3-9f78-ebeeae1b7902",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Wawa",
      "poi_type": "Shopping",
      "poi_address": "451 W Ridge Pike, Royersford, PA 19468, USA",
      "poi_short_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_long_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-702c-742e-a6cc-b15e98e9d02d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-702c-742e-a6cc-b15e98e9d02d",
        "storage_key": "property/6767906449166316/019fcdf6-702c-742e-a6cc-b15e98e9d02d.webp",
        "width": 500,
        "height": 400
      },
      "poi_business_url": "https://www.wawa.com/locations/8038?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=18229483087643511319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "40.232407",
      "poi_longitude": "-75.528409",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-495-4740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1d30-730d-af0d-a5b583c0272a",
        "storage_key": "property/6767906449166316/019d0266-1d30-730d-af0d-a5b583c0272a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEagLh8yaxokRF4r7xUgi_Pw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9a16955f-e2d5-4a90-9db8-0e6634283dd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping",
      "poi_address": "314 N Lewis Rd, Royersford, PA 19468, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-7082-727c-8691-196ecd11dfdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-7082-727c-8691-196ecd11dfdf",
        "storage_key": "property/6767906449166316/019fcdf6-7082-727c-8691-196ecd11dfdf.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/pa/royersford/12465",
      "poi_directions_map_url": "https://maps.google.com/?cid=4451793372571818832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "40.1955383",
      "poi_longitude": "-75.5336748",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 484-369-0230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-221f-72a2-aca1-5419dbbbccf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-221f-72a2-aca1-5419dbbbccf5",
        "storage_key": "property/6767906449166316/019d0266-221f-72a2-aca1-5419dbbbccf5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgQ1VcOSPxokRUNuUWXzyxz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7b02ec17-1d02-4e0d-807f-a88f23580cf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Marshalls",
      "poi_type": "Shopping",
      "poi_address": "979 S Township Line Rd, Royersford, PA 19468, USA",
      "poi_short_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_long_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-7258-742f-a900-bf1d4f28cb2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-7258-742f-a900-bf1d4f28cb2b",
        "storage_key": "property/6767906449166316/019fcdf6-7258-742f-a900-bf1d4f28cb2b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16161326272875995029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marshalls",
      "poi_latitude": "40.1951338",
      "poi_longitude": "-75.52918060000002",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-792-8805",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-221f-72a2-aca1-5419dbbbccf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-221f-72a2-aca1-5419dbbbccf5",
        "storage_key": "property/6767906449166316/019d0266-221f-72a2-aca1-5419dbbbccf5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJb-6I8uKPxokRlR_2aZ6QSOA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8cfeb7c1-bf73-43a0-811d-a23778f0c92b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping",
      "poi_address": "301 N Lewis Rd Suite #95, Limerick, PA 19468, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-757d-7529-b568-0efec01fd88c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-757d-7529-b568-0efec01fd88c",
        "storage_key": "property/6767906449166316/019fcdf6-757d-7529-b568-0efec01fd88c.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/pa/limerick/301-n-lewis-road-suite-95?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=15825884507876710345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "40.1929775",
      "poi_longitude": "-75.5350589",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 484-791-2240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-221f-72a2-aca1-5419dbbbccf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-221f-72a2-aca1-5419dbbbccf5",
        "storage_key": "property/6767906449166316/019d0266-221f-72a2-aca1-5419dbbbccf5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJO2yPEOSPxokRyVdZXBzWoNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_19817337-5616-4ee3-a2cd-747167bc0796",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Limerick Elementary school",
      "poi_type": "Education",
      "poi_address": "81 Limerick Center Rd, Royersford, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.spring-ford.net/our-schools/les",
      "poi_directions_map_url": "https://maps.google.com/?cid=7775650849602067023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "limerick-elementary-school",
      "poi_latitude": "40.2316502",
      "poi_longitude": "-75.5415249",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-705-6007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-22b1-731b-8319-173855e6967a",
        "storage_key": "property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-cy4wr-FxokRT9r-I0Cp6Gs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_424c489c-715e-4c20-8a7f-ba742e9c9ffb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Brooke Elementary School",
      "poi_type": "Education",
      "poi_address": "339 N Lewis Rd, Royersford, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.spring-ford.net/our-schools/brooke-elementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=3957767358238275816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brooke-elementary-school",
      "poi_latitude": "40.196368",
      "poi_longitude": "-75.5368136",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-705-6006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-22b1-731b-8319-173855e6967a",
        "storage_key": "property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv3Z8wuSPxokR6Lhtc3HQ7DY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2fc8ca14-b39d-4729-b748-2074ce33c6b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Evans Elementary School",
      "poi_type": "Education",
      "poi_address": "125 Sunset Rd, Royersford, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.spring-ford.net/our-schools/ees",
      "poi_directions_map_url": "https://maps.google.com/?cid=3530782997648615595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "evans-elementary-school",
      "poi_latitude": "40.2315167",
      "poi_longitude": "-75.51165759999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-705-6012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-22b1-731b-8319-173855e6967a",
        "storage_key": "property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz_ZFi8OaxokRq6jV8W3c_zA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_34a4b27f-23bb-4ba8-9262-146818be9118",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Spring-Ford Middle School 5/6/7 Grade Center",
      "poi_type": "Education",
      "poi_address": "833 S Lewis Rd #2, Royersford, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.spring-ford.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13287949399438946821&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-ford-middle-school-567-grade-center",
      "poi_latitude": "40.1882303",
      "poi_longitude": "-75.5141079",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 610-705-6010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-22b1-731b-8319-173855e6967a",
        "storage_key": "property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwb2frhaQxokRBXLsgpNHaLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6d7cfae6-5d99-4da8-a473-0e15a0a0b9cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Spring-Ford Middle School 8th Grade Center",
      "poi_type": "Education",
      "poi_address": "700 Washington St, Royersford, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.spring-ford.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10849603960140346030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-ford-middle-school-8th-grade-center",
      "poi_latitude": "40.18716149999999",
      "poi_longitude": "-75.53121829999999",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 610-705-6002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-22b1-731b-8319-173855e6967a",
        "storage_key": "property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZxh7oeCPxokRrjLWbVGJkZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2b3ec279-75f6-4053-b265-a30dbc108a37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Spring-Ford Area High School 10-12 Grade Center",
      "poi_type": "Education",
      "poi_address": "350 S Lewis Rd, Royersford, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.spring-ford.net/our-schools/spring-ford-area-high-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=12183844352612683440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-ford-area-high-school-10-12-grade-center",
      "poi_latitude": "40.18982219999999",
      "poi_longitude": "-75.52566829999999",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 610-705-6001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-22b1-731b-8319-173855e6967a",
        "storage_key": "property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu_14HOCPxokRsM4gzOK1Fak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1d2a69e8-0c03-4545-a2fd-e7fdd51d5463",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Western Montgomery Career and Technology Center",
      "poi_type": "Education",
      "poi_address": "77 Graterford Rd, Royersford, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.westerncenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1230339059897307598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "western-montgomery-career-and-technology-center",
      "poi_latitude": "40.23646129999999",
      "poi_longitude": "-75.5081956",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 610-489-7272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-22b1-731b-8319-173855e6967a",
        "storage_key": "property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuTwpvNyaxokRzpF3OtsKExE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_73914aad-3442-4d3c-96b0-72f53f645d86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Chesterbrook Academy Preschool",
      "poi_type": "Education",
      "poi_address": "441 N Lewis Rd, Limerick, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-7628-76ff-a4bd-2a6af17467d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-7628-76ff-a4bd-2a6af17467d5",
        "storage_key": "property/6767906449166316/019fcdf6-7628-76ff-a4bd-2a6af17467d5.webp",
        "width": 1280,
        "height": 770
      },
      "poi_business_url": "https://www.chesterbrookacademy.com/preschools/pa/montgomery-county/limerick/?utm_medium=directory&utm_source=gmb&utm_campaign=profile&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=13282961021002831436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesterbrook-academy-preschool",
      "poi_latitude": "40.2061834",
      "poi_longitude": "-75.5416961",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-753-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-22b1-731b-8319-173855e6967a",
        "storage_key": "property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV5PQCfePxokRTNY7JqyOVrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_184f8d65-a0b8-463e-9857-2132fd829f3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Childtime of Limerick",
      "poi_type": "Education",
      "poi_address": "36 W Ridge Pike, Limerick, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-7732-746b-9fb5-5684aed8c741.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-7732-746b-9fb5-5684aed8c741",
        "storage_key": "property/6767906449166316/019fcdf6-7732-746b-9fb5-5684aed8c741.webp",
        "width": 579,
        "height": 573
      },
      "poi_business_url": "https://www.childtime.com/your-local-school/limerick-pa-1604?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=1604",
      "poi_directions_map_url": "https://maps.google.com/?cid=4034089367406353080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childtime-of-limerick",
      "poi_latitude": "40.2176485",
      "poi_longitude": "-75.50134650000001",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 877-220-0584",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-22b1-731b-8319-173855e6967a",
        "storage_key": "property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8-x9TEubxokRuJpv-Of2-zc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_60dcee1d-ab67-41c1-86c8-51f2884fc2bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "The Malvern School & Child Care Center Royersford",
      "poi_type": "Education",
      "poi_address": "538 N Lewis Rd, Royersford, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-7879-736b-8f29-54c52c0e0771.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-7879-736b-8f29-54c52c0e0771",
        "storage_key": "property/6767906449166316/019fcdf6-7879-736b-8f29-54c52c0e0771.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://malvernschool.com/our-schools/location/royersford-preschool/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=1817369656487626341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-malvern-school--child-care-center-royersford",
      "poi_latitude": "40.21327710000001",
      "poi_longitude": "-75.54339279999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 610-792-8808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-22b1-731b-8319-173855e6967a",
        "storage_key": "property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKc_iTFmFxokRZcaE4BKYOBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_31aaab1d-fb91-48cb-a831-72934b99488e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Arnold's Family Fun Center",
      "poi_type": "Entertainment",
      "poi_address": "2200 West Dr, Oaks, PA 19456, USA",
      "poi_short_description": "Huge activity center for all ages featuring mini-golf, arcade games & laser tag.",
      "poi_long_description": "Huge activity center for all ages featuring mini-golf, arcade games & laser tag.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-7bbc-7789-8563-15bbaf6e4246.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-7bbc-7789-8563-15bbaf6e4246",
        "storage_key": "property/6767906449166316/019fcdf6-7bbc-7789-8563-15bbaf6e4246.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.arnoldsffc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12176540693777852054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arnolds-family-fun-center",
      "poi_latitude": "40.1234895",
      "poi_longitude": "-75.4564767",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 610-666-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ82E5UGeRxokRlqa3NT_D-6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0d3e290e-cf74-4b32-b56e-1d2e4094b131",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "American Treasure Tour Museum",
      "poi_type": "Entertainment",
      "poi_address": "One American Treasure Way, Oaks, PA 19456, USA",
      "poi_short_description": "Unique place displaying eclectic Americana, including antiques, kitsch & pop culture items.",
      "poi_long_description": "Unique place displaying eclectic Americana, including antiques, kitsch & pop culture items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-7c23-7168-9381-164609eabf61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-7c23-7168-9381-164609eabf61",
        "storage_key": "property/6767906449166316/019fcdf6-7c23-7168-9381-164609eabf61.webp",
        "width": 1000,
        "height": 664
      },
      "poi_business_url": "http://www.americantreasuretour.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=530213735879516942&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-treasure-tour-museum",
      "poi_latitude": "40.1239881",
      "poi_longitude": "-75.45363119999999",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 866-970-8687",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-268d-73a3-bccb-ca8977a11d18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-268d-73a3-bccb-ca8977a11d18",
        "storage_key": "property/6767906449166316/019d0266-268d-73a3-bccb-ca8977a11d18.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJc_Rw0F2RxokRDqMhZpWyWwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_41213f4e-2347-4735-8814-d897fed08f52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Regal Oaks",
      "poi_type": "Entertainment",
      "poi_address": "180 Mill Rd, Oaks, PA 19456, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-7d9b-7212-8933-8572edba3a71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-7d9b-7212-8933-8572edba3a71",
        "storage_key": "property/6767906449166316/019fcdf6-7d9b-7212-8933-8572edba3a71.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-oaks/0340?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8754447372922986642&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-oaks",
      "poi_latitude": "40.127525",
      "poi_longitude": "-75.45324099999999",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-26bd-73e8-a04f-16b66a9e5493.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-26bd-73e8-a04f-16b66a9e5493",
        "storage_key": "property/6767906449166316/019d0266-26bd-73e8-a04f-16b66a9e5493.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJReYt-0KRxokRkiDtq4ALfnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4c14650d-0a18-4127-8e2a-854b0181b3d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "The Greater Philadelphia Expo Center & Fairgrounds",
      "poi_type": "Entertainment",
      "poi_address": "100 Station Ave, Oaks, PA 19456, USA",
      "poi_short_description": "Spacious venue for trade shows and expos, also hosting conventions, tournaments and other events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-7f97-7168-8226-014f8a965560.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-7f97-7168-8226-014f8a965560",
        "storage_key": "property/6767906449166316/019fcdf6-7f97-7168-8226-014f8a965560.webp",
        "width": 1078,
        "height": 720
      },
      "poi_business_url": "https://www.phillyexpocenter.com/?utm_campaign=gmb&utm_medium=organic&utm_source=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9737191855775804639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-greater-philadelphia-expo-center--fairgrounds",
      "poi_latitude": "40.1238562",
      "poi_longitude": "-75.4580644",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 484-754-3976",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZBwWmeRxokR3-xXKWd0IYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3c93a23d-6e67-430c-8182-7332b5581925",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Elmwood Park Zoo",
      "poi_type": "Entertainment",
      "poi_address": "1661 Harding Blvd, Norristown, PA 19401, USA",
      "poi_short_description": "Small zoo featuring wildlife from around the world like jaguars, zebras and otters.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-830a-76d0-8336-c93c93b6b4d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-830a-76d0-8336-c93c93b6b4d6",
        "storage_key": "property/6767906449166316/019fcdf6-830a-76d0-8336-c93c93b6b4d6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.elmwoodparkzoo.org/?utm_source=GMB&utm_medium=organic&utm_campaign=1SEO_SM",
      "poi_directions_map_url": "https://maps.google.com/?cid=9161381553617211572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elmwood-park-zoo",
      "poi_latitude": "40.1327855",
      "poi_longitude": "-75.3385921",
      "poi_miles_from_property": "14.4 mi",
      "poi_walking_minutes": "5 hours 20 mins",
      "poi_biking_minutes": "1 hour 54 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 610-277-3825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfd-he4i9xokRtJAr4_vDI38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1ec7baab-1f87-440b-b08d-0c30bad51a66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Visitor Center At Valley Forge",
      "poi_type": "Entertainment",
      "poi_address": "1400 N Outer Line Dr, King of Prussia, PA 19406, USA",
      "poi_short_description": "Information-packed, clean center offering exhibits and a gift shop that covers the history of Valley Forge and its role in the American Revolution.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-83d2-7648-938e-e294961e6840.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-83d2-7648-938e-e294961e6840",
        "storage_key": "property/6767906449166316/019fcdf6-83d2-7648-938e-e294961e6840.webp",
        "width": 591,
        "height": 1280
      },
      "poi_business_url": "https://www.nps.gov/vafo/planyourvisit/basicinfo.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=759934785609447074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "visitor-center-at-valley-forge",
      "poi_latitude": "40.1013364",
      "poi_longitude": "-75.4223261",
      "poi_miles_from_property": "16.1 mi",
      "poi_walking_minutes": "5 hours 55 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 610-783-1099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjb_BIBCUxokRora2RKnUiwo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9a8f87b4-1504-447c-837e-fba9ccf41a3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Valley Forge Casino Resort",
      "poi_type": "Entertainment",
      "poi_address": "1160 1st Ave, King of Prussia, PA 19406, USA",
      "poi_short_description": "Casual casino hotel offering a spa, a seasonal outdoor pool & dining, plus 2 event venues.",
      "poi_long_description": "Casual casino hotel offering a spa, a seasonal outdoor pool & dining, plus 2 event venues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-839d-764a-8c42-ca8f27034301.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-839d-764a-8c42-ca8f27034301",
        "storage_key": "property/6767906449166316/019fcdf6-839d-764a-8c42-ca8f27034301.webp",
        "width": 1280,
        "height": 744
      },
      "poi_business_url": "https://vfcasino.boydgaming.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2291201520255392785&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-forge-casino-resort",
      "poi_latitude": "40.096667",
      "poi_longitude": "-75.41576049999999",
      "poi_miles_from_property": "16.6 mi",
      "poi_walking_minutes": "6 hours 5 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 610-354-8118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2785-7319-919e-228ec928a0ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2785-7319-919e-228ec928a0ee",
        "storage_key": "property/6767906449166316/019d0266-2785-7319-919e-228ec928a0ee.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJq_cSUhSUxokREVyos6T7yx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_91ad542e-8e5d-4815-b46e-4eca09561b5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "King of Prussia",
      "poi_type": "Entertainment",
      "poi_address": "160 N Gulph Rd, King of Prussia, PA 19406, USA",
      "poi_short_description": "Sprawling & elegant, skylit indoor mall with 400+ retailers, plus food courts & restaurants.",
      "poi_long_description": "Sprawling & elegant, skylit indoor mall with 400+ retailers, plus food courts & restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-865b-75b9-8b32-4d947de815d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-865b-75b9-8b32-4d947de815d4",
        "storage_key": "property/6767906449166316/019fcdf6-865b-75b9-8b32-4d947de815d4.webp",
        "width": 1218,
        "height": 1280
      },
      "poi_business_url": "https://www.simon.com/mall/king-of-prussia",
      "poi_directions_map_url": "https://maps.google.com/?cid=2433808766029087397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-of-prussia",
      "poi_latitude": "40.0885889",
      "poi_longitude": "-75.3928932",
      "poi_miles_from_property": "17.5 mi",
      "poi_walking_minutes": "6 hours 32 mins",
      "poi_biking_minutes": "2 hours 12 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 610-265-5727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-221f-72a2-aca1-5419dbbbccf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-221f-72a2-aca1-5419dbbbccf5",
        "storage_key": "property/6767906449166316/019d0266-221f-72a2-aca1-5419dbbbccf5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZYcLs0qUxokRpUJlhi2gxiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_00fe1c97-e23e-443e-b885-ee28ada2a017",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Movie Tavern Collegeville",
      "poi_type": "Entertainment",
      "poi_address": "140 Market St, Collegeville, PA 19426, USA",
      "poi_short_description": "Theater showing new releases paired with gourmet eats & cocktails available at the push of a button.",
      "poi_long_description": "Theater showing new releases paired with gourmet eats & cocktails available at the push of a button.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-8a20-7188-84f4-f8b2c4a28767.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-8a20-7188-84f4-f8b2c4a28767",
        "storage_key": "property/6767906449166316/019fcdf6-8a20-7188-84f4-f8b2c4a28767.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.marcustheatres.com/theatre-locations/movie-tavern-collegeville",
      "poi_directions_map_url": "https://maps.google.com/?cid=12838170920645916317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "movie-tavern-collegeville",
      "poi_latitude": "40.1665345",
      "poi_longitude": "-75.4797928",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 610-831-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-26bd-73e8-a04f-16b66a9e5493.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-26bd-73e8-a04f-16b66a9e5493",
        "storage_key": "property/6767906449166316/019d0266-26bd-73e8-a04f-16b66a9e5493.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJoejDVWaJsIkRnXbZym5YKrI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_577b8cfc-989c-4f7d-a1e7-63913e01008f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "The Colonial Theatre",
      "poi_type": "Entertainment",
      "poi_address": "227 Bridge St, Phoenixville, PA 19460, USA",
      "poi_short_description": "Elegant 1903 movie house showing new-release independent & classic films, plus live performances.",
      "poi_long_description": "Elegant 1903 movie house showing new-release independent & classic films, plus live performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-897a-7698-8fe2-9e8ad20875c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-897a-7698-8fe2-9e8ad20875c0",
        "storage_key": "property/6767906449166316/019fcdf6-897a-7698-8fe2-9e8ad20875c0.webp",
        "width": 1280,
        "height": 730
      },
      "poi_business_url": "http://www.thecolonialtheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5241659315191761049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-colonial-theatre",
      "poi_latitude": "40.13407249999999",
      "poi_longitude": "-75.517511",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 610-917-1228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-26bd-73e8-a04f-16b66a9e5493.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-26bd-73e8-a04f-16b66a9e5493",
        "storage_key": "property/6767906449166316/019d0266-26bd-73e8-a04f-16b66a9e5493.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8yyxlPqRxokRmUifK2Advkg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c0aea125-dc5f-4d02-aa58-d0161b3413bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Pottstown Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1600 E High St, Pottstown, PA 19464, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-89fd-709a-92f9-dce71b668415.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-89fd-709a-92f9-dce71b668415",
        "storage_key": "property/6767906449166316/019fcdf6-89fd-709a-92f9-dce71b668415.webp",
        "width": 750,
        "height": 750
      },
      "poi_business_url": "https://towerhealth.org/locations/pottstown-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=10594659352548128736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pottstown-hospital",
      "poi_latitude": "40.2426719",
      "poi_longitude": "-75.6121704",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-327-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5cvWC1GGxokR4LfmWIzKB5M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4d82a1da-9b41-45b2-ac40-5f51def8f444",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Tower Health Medical Group Family Medicine - Limerick",
      "poi_type": "Health and Wellness",
      "poi_address": "420 W Linfield-Trappe Rd Bldg 100 Ste 3100, Limerick, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-8e8a-72db-ba80-63c32f387e12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-8e8a-72db-ba80-63c32f387e12",
        "storage_key": "property/6767906449166316/019fcdf6-8e8a-72db-ba80-63c32f387e12.webp",
        "width": 736,
        "height": 736
      },
      "poi_business_url": "https://towerhealth.org/locations/tower-health-medical-group-family-medicine-limerick",
      "poi_directions_map_url": "https://maps.google.com/?cid=15489582476914798595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tower-health-medical-group-family-medicine---limerick",
      "poi_latitude": "40.2163719",
      "poi_longitude": "-75.5417719",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 610-495-3762",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqYmIgYyFxokRAzCfBzIN9tY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_10945ed5-b8fb-4823-91b0-07fc2f885166",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Rothman Orthopaedics - Limerick Walk-In Center",
      "poi_type": "Health and Wellness",
      "poi_address": "400 Enterprise Dr 1st Floor, Royersford, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-8f58-741c-8148-f3850b45027b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-8f58-741c-8148-f3850b45027b",
        "storage_key": "property/6767906449166316/019fcdf6-8f58-741c-8148-f3850b45027b.webp",
        "width": 960,
        "height": 480
      },
      "poi_business_url": "https://rothmanortho.com/locations/limerick-urgent-care?utm_source=Yext&utm_medium=SearchEngineUrgentCare&y_source=1_MTM3MDc5MjMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5440853864485044870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rothman-orthopaedics---limerick-walk-in-center",
      "poi_latitude": "40.2162388",
      "poi_longitude": "-75.5520648",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 484-932-5065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-b8FaGeFxokRhkJxS8PLgUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3924fc96-7321-46c6-8522-c19071778ba3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "5 Kugler Rd BUILDING 100, Limerick, PA 19468, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-9088-7541-8689-81f92360b648.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-9088-7541-8689-81f92360b648",
        "storage_key": "property/6767906449166316/019fcdf6-9088-7541-8689-81f92360b648.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/limerick-pa-pharmacies/5-kugler-road-building-100-limerick-pa-19468/storeid=2690?WT.mc_id=LS_GOOGLE_FS_2690",
      "poi_directions_map_url": "https://maps.google.com/?cid=8343163860217956058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "40.2378033",
      "poi_longitude": "-75.5370865",
      "poi_miles_from_property": "459 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-495-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9W_nKDCFxokR2gYrr1PfyHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7ded0957-4afd-4e44-8f0c-baa87b41eb1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "30 W Ridge Pike, Limerick, PA 19468, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-90bc-71bd-8df8-abe83e6db602.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-90bc-71bd-8df8-abe83e6db602",
        "storage_key": "property/6767906449166316/019fcdf6-90bc-71bd-8df8-abe83e6db602.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-30+w+ridge+pike-limerick-pa-19468/id=10958",
      "poi_directions_map_url": "https://maps.google.com/?cid=3922334413549985865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "40.2165351",
      "poi_longitude": "-75.5010029",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 610-454-7295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-21e1-73b9-8260-7ff5e213e20d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21e1-73b9-8260-7ff5e213e20d",
        "storage_key": "property/6767906449166316/019d0266-21e1-73b9-8260-7ff5e213e20d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf-MV-paaxokRSeDvIV7ubjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bc653fa2-b190-40e9-ae6c-caf06a511cb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "33 W Ridge Pike Ste 401, Royersford, PA 19468, USA",
      "poi_short_description": "Casual fitness center featuring cardio machines, dumbbells, free weights, smith machines, hydro massage chairs, tanning beds and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-9501-705c-b0d4-e2a10536695d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-9501-705c-b0d4-e2a10536695d",
        "storage_key": "property/6767906449166316/019fcdf6-9501-705c-b0d4-e2a10536695d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/limerick-pa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=5159403118273675978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.214815",
      "poi_longitude": "-75.5026484",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 484-791-2220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXXsvHn6bxokRysK-5czhmUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c562a662-9235-4622-9d9c-f9915182bb36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "130 W Main St Ste. 100B, Trappe, PA 19426, USA",
      "poi_short_description": "Relaxed, clean 24/7 training center featuring a range of equipment, plus classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-9698-7682-a226-bc000cf821ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-9698-7682-a226-bc000cf821ce",
        "storage_key": "property/6767906449166316/019fcdf6-9698-7682-a226-bc000cf821ce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/trappe-pennsylvania-3926/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=3926",
      "poi_directions_map_url": "https://maps.google.com/?cid=11943469363224062972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "40.1944917",
      "poi_longitude": "-75.4673242",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 484-752-4449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7x9Vi2GxokR_Cu7TBu6v6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_094d0272-33fe-4c4f-a7b0-9d252be3381f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "F45 Training Royersford",
      "poi_type": "Health and Wellness",
      "poi_address": "1839 E Ridge Pike, Royersford, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-96c1-77ff-9cb3-db480d931024.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-96c1-77ff-9cb3-db480d931024",
        "storage_key": "property/6767906449166316/019fcdf6-96c1-77ff-9cb3-db480d931024.webp",
        "width": 948,
        "height": 533
      },
      "poi_business_url": "https://f45training.com/studio/royersford/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4354374754375431835&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "f45-training-royersford",
      "poi_latitude": "40.2142621",
      "poi_longitude": "-75.4973997",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-420-5578",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe_96N46bxokRm_Z5xcTYbTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ccdb72c5-3564-4da3-8ee3-4ec3a5f5ea3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "TORQUE Spin, Barre, & TRX Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "328 N Lewis Rd, Royersford, PA 19468, USA",
      "poi_short_description": "Fitness and gym-style facility offering barre, yoga and TRX workouts along with childcare.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-978d-729f-afbe-a7889b54b3ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-978d-729f-afbe-a7889b54b3ed",
        "storage_key": "property/6767906449166316/019fcdf6-978d-729f-afbe-a7889b54b3ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thetorquemovement.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11536414036792071831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "torque-spin-barre--trx-studio",
      "poi_latitude": "40.1963327",
      "poi_longitude": "-75.5343465",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 484-961-8295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTQIRCoSaxokRl1bSpHGTGaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ccc1025a-ed36-4064-b912-decec27af72d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "OsteoStrong Limerick Central",
      "poi_type": "Health and Wellness",
      "poi_address": "100 W Ridge Pike Suite 201, Limerick, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-9cc7-74b8-8cbd-c39d1c33e9f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-9cc7-74b8-8cbd-c39d1c33e9f4",
        "storage_key": "property/6767906449166316/019fcdf6-9cc7-74b8-8cbd-c39d1c33e9f4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.osteostronglimerick.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15832631148821674962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "osteostrong-limerick-central",
      "poi_latitude": "40.2195721",
      "poi_longitude": "-75.50599059999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-678-3663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC4NDSkWbxokR0vtMHSXOuNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9c724fc4-a6fc-4ce0-9f62-d7d528c1ce42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Limerick Community Park",
      "poi_type": "Recreation",
      "poi_address": "180 Swamp Pike, Royersford, PA 19468, USA",
      "poi_short_description": "Public park with a playground, picnic pavilions, basketball and volleyball courts, and a baseball field.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-9ca9-755f-93f8-10edc1e09567.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-9ca9-755f-93f8-10edc1e09567",
        "storage_key": "property/6767906449166316/019fcdf6-9ca9-755f-93f8-10edc1e09567.webp",
        "width": 1280,
        "height": 989
      },
      "poi_business_url": "http://www.limerickpa.org/Facilities/Facility/Details/Limerick-Community-Park-1",
      "poi_directions_map_url": "https://maps.google.com/?cid=4928219132440211210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "limerick-community-park",
      "poi_latitude": "40.2410323",
      "poi_longitude": "-75.52839929999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-495-6432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2789-737a-81f6-f20a9b173183",
        "storage_key": "property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFdT9nNSaxokRCu9hrDCNZEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_02b72ba6-8510-4ef7-81de-3539c0cef445",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Limerick Community Park",
      "poi_type": "Recreation",
      "poi_address": "180 Swamp Pike, Royersford, PA 19468, USA",
      "poi_short_description": "Public park with a playground, picnic pavilions, basketball and volleyball courts, and a baseball field.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-9ca9-755f-93f8-10edc1e09567.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-9ca9-755f-93f8-10edc1e09567",
        "storage_key": "property/6767906449166316/019fcdf6-9ca9-755f-93f8-10edc1e09567.webp",
        "width": 1280,
        "height": 989
      },
      "poi_business_url": "http://www.limerickpa.org/Facilities/Facility/Details/Limerick-Community-Park-1",
      "poi_directions_map_url": "https://maps.google.com/?cid=4928219132440211210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "limerick-community-park",
      "poi_latitude": "40.2410323",
      "poi_longitude": "-75.52839929999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-495-6432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2789-737a-81f6-f20a9b173183",
        "storage_key": "property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFdT9nNSaxokRCu9hrDCNZEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f35f8aa6-b7f2-4e4a-a79c-d2e404e7fe68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Trinley Park",
      "poi_type": "Recreation",
      "poi_address": "Trinley Mill Rd, Royersford, PA 19468, USA",
      "poi_short_description": "Quiet, scenic park featuring the Schuylkill River as well as picnic tables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-9f01-70a0-a0cf-8a3597f201e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-9f01-70a0-a0cf-8a3597f201e0",
        "storage_key": "property/6767906449166316/019fcdf6-9f01-70a0-a0cf-8a3597f201e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.limerickpa.org/facilities/facility/details/Trinley-River-Park-3",
      "poi_directions_map_url": "https://maps.google.com/?cid=16014315437029617995&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinley-park",
      "poi_latitude": "40.2099254",
      "poi_longitude": "-75.56461929999999",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 610-495-6432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2789-737a-81f6-f20a9b173183",
        "storage_key": "property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_cd5u4ePxokRS3E04QpHPt4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0b8e7cfd-c78d-40ef-a1ad-1fdb40b4513f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Linfield Sports Park",
      "poi_type": "Recreation",
      "poi_address": "14 Longview Rd, Royersford, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5263974689411415777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "linfield-sports-park",
      "poi_latitude": "40.2075621",
      "poi_longitude": "-75.57533819999999",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2789-737a-81f6-f20a9b173183",
        "storage_key": "property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqtniPxokR4b4DHRdlDUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_31edfaf2-c229-45be-b6c7-e86a24577d88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Kurylo Preserve",
      "poi_type": "Recreation",
      "poi_address": "Neiffer, PA 19473, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-9e44-74aa-ab7c-fb90ec66a5a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-9e44-74aa-ab7c-fb90ec66a5a4",
        "storage_key": "property/6767906449166316/019fcdf6-9e44-74aa-ab7c-fb90ec66a5a4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10156128475406702385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kurylo-preserve",
      "poi_latitude": "40.2426969",
      "poi_longitude": "-75.5122133",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2789-737a-81f6-f20a9b173183",
        "storage_key": "property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJp9XOpsKbxokRMZfY9QnR8Yw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e8acd8f1-ede4-4d14-8ce3-cea500b1a411",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Natural Lands' Stone Hills Preserve",
      "poi_type": "Recreation",
      "poi_address": "124 Laver Rd, Schwenksville, PA 19473, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-a489-703e-a82f-5c17cc68b0ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-a489-703e-a82f-5c17cc68b0ee",
        "storage_key": "property/6767906449166316/019fcdf6-a489-703e-a82f-5c17cc68b0ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://natlands.org/stone-hills-preserve/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9865260960210730476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "natural-lands-stone-hills-preserve",
      "poi_latitude": "40.2611157",
      "poi_longitude": "-75.5291514",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 610-353-5587",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2789-737a-81f6-f20a9b173183",
        "storage_key": "property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu-TwVDObxokR7L3jLZNy6Ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d401618d-62f4-4e77-80ef-5470fc26f596",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Upper Schuylkill Valley Park",
      "poi_type": "Recreation",
      "poi_address": "1615 Black Rock Rd, Royersford, PA 19468, USA",
      "poi_short_description": "Relaxed animal park with wolves and birds of prey, plus trails and a reptile house.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-a506-7747-9f3e-22038b11dda4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-a506-7747-9f3e-22038b11dda4",
        "storage_key": "property/6767906449166316/019fcdf6-a506-7747-9f3e-22038b11dda4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.montcopa.org/875/Upper-Schuylkill-Valley-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4095354732975347330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upper-schuylkill-valley-park",
      "poi_latitude": "40.1626889",
      "poi_longitude": "-75.5088682",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 610-948-5170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ41PKfsyRxokRgtY1eG6f1Tg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9dd364f3-fe5a-4d32-b501-e05e2020cd16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Royersford Riverfront Park",
      "poi_type": "Recreation",
      "poi_address": "Royersford, PA 19468, USA",
      "poi_short_description": "Recreation area offering a walking path along the river, picnic tables, and a rowing team.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-a58e-73ac-82b5-38cbbd307c78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-a58e-73ac-82b5-38cbbd307c78",
        "storage_key": "property/6767906449166316/019fcdf6-a58e-73ac-82b5-38cbbd307c78.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://trails.dcnr.pa.gov/trails/trail/trailview?trailkey=551",
      "poi_directions_map_url": "https://maps.google.com/?cid=10983270184991441325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "royersford-riverfront-park",
      "poi_latitude": "40.181118",
      "poi_longitude": "-75.5433801",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2789-737a-81f6-f20a9b173183",
        "storage_key": "property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7b6JtMWPxokRrcGNmApqbJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a324e273-d1a0-4415-ba78-bd2b9f324e8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Lock 60 Recreation Area",
      "poi_type": "Recreation",
      "poi_address": "Locktender's House, 400 Tow Path Rd, Mont Clare, PA 19453, USA",
      "poi_short_description": "Part of Schuykill Canal Park, this area has a restored 1820s lock & house, a boat ramp & loop trail.",
      "poi_long_description": "Part of Schuykill Canal Park, this area has a restored 1820s lock & house, a boat ramp & loop trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-a71f-711a-9f92-a9b4681d2b1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-a71f-711a-9f92-a9b4681d2b1a",
        "storage_key": "property/6767906449166316/019fcdf6-a71f-711a-9f92-a9b4681d2b1a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.montgomerycountypa.gov/1145/Lock-60-at-the-Schuylkill-Canal-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16403238201052385701&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lock-60-recreation-area",
      "poi_latitude": "40.1446742",
      "poi_longitude": "-75.5085182",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 610-917-0021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2789-737a-81f6-f20a9b173183",
        "storage_key": "property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJhQi4JJGRxokRpVHYWzwCpOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e4baa702-c4db-491d-9f05-b45130806bdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Black Rock Sanctuary",
      "poi_type": "Recreation",
      "poi_address": "953 Black Rock Road, PA-113, Phoenixville, PA 19460, USA",
      "poi_short_description": "This 119-acre tract with a variety of habitats for birds & animals offers an interpretive trail.",
      "poi_long_description": "This 119-acre tract with a variety of habitats for birds & animals offers an interpretive trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-ac2c-70ca-84fa-fd8d04e50833.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-ac2c-70ca-84fa-fd8d04e50833",
        "storage_key": "property/6767906449166316/019fcdf6-ac2c-70ca-84fa-fd8d04e50833.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.chesco.org/4624/Black-Rock-Sanctuary",
      "poi_directions_map_url": "https://maps.google.com/?cid=10266176003811760009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-rock-sanctuary",
      "poi_latitude": "40.1528745",
      "poi_longitude": "-75.5072234",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 610-344-6415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2789-737a-81f6-f20a9b173183",
        "storage_key": "property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr4psC8iRxokRidfW1K7IeI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b4302e17-5881-4460-a720-c47b52d201ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Ridge Pk & Limerick Rd",
      "poi_type": "Transportation",
      "poi_address": "Limerick Township, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13005933132440219020&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridge-pk--limerick-rd",
      "poi_latitude": "40.230999",
      "poi_longitude": "-75.521896",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmePN_8uaxokRjC2Vi0ZbfrQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_987a5d00-7b30-4a43-8546-e230431d70be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Main St & Lewis Rd",
      "poi_type": "Transportation",
      "poi_address": "Royersford, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=425085139401347946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-st--lewis-rd",
      "poi_latitude": "40.19085",
      "poi_longitude": "-75.53214",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJse1wPuGPxokRapNQna405gU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1247cc06-9265-48e3-9f34-c7434ff9be25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Park and ride",
      "poi_type": "Transportation",
      "poi_address": "579 N Lewis Rd, Royersford, PA 19468, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-ac6a-74e8-9b65-83e62f7baf20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-ac6a-74e8-9b65-83e62f7baf20",
        "storage_key": "property/6767906449166316/019fcdf6-ac6a-74e8-9b65-83e62f7baf20.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4674080729104597051&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park-and-ride",
      "poi_latitude": "40.2146769",
      "poi_longitude": "-75.5454204",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2b28-76da-9718-7871fffa3113.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2b28-76da-9718-7871fffa3113",
        "storage_key": "property/6767906449166316/019d0266-2b28-76da-9718-7871fffa3113.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5Zh05baFxokRO0DHpair3UA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5748358c-69aa-49fe-8757-3dfa69825220",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Norristown Transit Center",
      "poi_type": "Transportation",
      "poi_address": "Norristown, PA 19401, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-ad09-72a9-b0b9-9f69751321d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-ad09-72a9-b0b9-9f69751321d1",
        "storage_key": "property/6767906449166316/019fcdf6-ad09-72a9-b0b9-9f69751321d1.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.septa.org/maps/station/ntc.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5783245876352578000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "norristown-transit-center",
      "poi_latitude": "40.1126365",
      "poi_longitude": "-75.3441404",
      "poi_miles_from_property": "13.9 mi",
      "poi_walking_minutes": "5 hours 8 mins",
      "poi_biking_minutes": "1 hour 45 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2b26-7776-bc28-5ea9ed3b52e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2b26-7776-bc28-5ea9ed3b52e4",
        "storage_key": "property/6767906449166316/019d0266-2b26-7776-bc28-5ea9ed3b52e4.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJwwfnKQOWxokR0PG8zHs3QlA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8492309e-0c21-415d-9804-2330389cdabc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Elm Street-Norristown Station",
      "poi_type": "Transportation",
      "poi_address": "793 Markley St, Norristown, PA 19401, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://rymap.org/business/elm-street-norristown-station-4civyb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12409656047487459795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elm-street-norristown-station",
      "poi_latitude": "40.12095230000001",
      "poi_longitude": "-75.3447599",
      "poi_miles_from_property": "13.7 mi",
      "poi_walking_minutes": "5 hours 3 mins",
      "poi_biking_minutes": "1 hour 46 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 215-580-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2b28-76da-9718-7871fffa3113.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2b28-76da-9718-7871fffa3113",
        "storage_key": "property/6767906449166316/019d0266-2b28-76da-9718-7871fffa3113.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJdzMYAx-WxokR06FED230N6w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7cdd9e0f-52a7-4ab4-a463-83cc06116576",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Main Street",
      "poi_type": "Transportation",
      "poi_address": "Norristown, PA 19401, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-ad9e-772d-941f-edbf34ff8544.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-ad9e-772d-941f-edbf34ff8544",
        "storage_key": "property/6767906449166316/019fcdf6-ad9e-772d-941f-edbf34ff8544.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.septa.org/stations/rail/mainstreet.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16911559264398374602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-street",
      "poi_latitude": "40.1170836",
      "poi_longitude": "-75.34875749999999",
      "poi_miles_from_property": "13.4 mi",
      "poi_walking_minutes": "4 hours 57 mins",
      "poi_biking_minutes": "1 hour 43 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2b26-7776-bc28-5ea9ed3b52e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2b26-7776-bc28-5ea9ed3b52e4",
        "storage_key": "property/6767906449166316/019d0266-2b26-7776-bc28-5ea9ed3b52e4.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJlYhtvhuWxokRynZuuIztseo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_975ff61a-a117-41fa-927e-5784498b92c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "King of Prussia SEPTA Transit Center",
      "poi_type": "Transportation",
      "poi_address": "1001 King of Prussia Plaza, King of Prussia, PA 19406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-b2c2-7572-8f73-f33a3e651bb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-b2c2-7572-8f73-f33a3e651bb4",
        "storage_key": "property/6767906449166316/019fcdf6-b2c2-7572-8f73-f33a3e651bb4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15797788323557232326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-of-prussia-septa-transit-center",
      "poi_latitude": "40.0893854",
      "poi_longitude": "-75.39283209999999",
      "poi_miles_from_property": "17.5 mi",
      "poi_walking_minutes": "6 hours 32 mins",
      "poi_biking_minutes": "2 hours 11 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 855-567-3782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSRsG9zWUxokRxk5xrscEPds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_93f19d05-5d31-40c2-9def-94ccaeff5f88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Charles W. Dickinson transportation center",
      "poi_type": "Transportation",
      "poi_address": "Pottstown Bypass, Pottstown, PA 19464, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://pottstownarearapidtransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2327503230775566703&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charles-w-dickinson-transportation-center",
      "poi_latitude": "40.2450372",
      "poi_longitude": "-75.6515929",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 610-326-5413",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSRnc94mHxokRb6HzU9vzTCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e8849c7d-3d5e-4b40-b091-fb6c28701a02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Philadelphia International Airport",
      "poi_type": "Transportation",
      "poi_address": "8500 Essington Ave, Philadelphia, PA 19153, USA",
      "poi_short_description": "Large hub with direct rail service, rotating art exhibitions & aviation-themed play areas for kids.",
      "poi_long_description": "Large hub with direct rail service, rotating art exhibitions & aviation-themed play areas for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-b39f-7488-ad5c-44f16a916ddc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-b39f-7488-ad5c-44f16a916ddc",
        "storage_key": "property/6767906449166316/019fcdf6-b39f-7488-ad5c-44f16a916ddc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.phl.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4480542405857629144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "philadelphia-international-airport",
      "poi_latitude": "39.87297969999999",
      "poi_longitude": "-75.24369870000001",
      "poi_miles_from_property": "42.6 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "3 hours 46 mins",
      "poi_driving_minutes": "49 mins",
      "poi_business_phone": "+1 215-937-6937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2cd7-73c8-93a8-9edaf21757ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2cd7-73c8-93a8-9edaf21757ff",
        "storage_key": "property/6767906449166316/019d0266-2cd7-73c8-93a8-9edaf21757ff.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJL4OpYGbExokR2NM3RpQVLj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5fc2b9bc-61f1-4958-9411-4dc78d1f887e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Schuylkill River Trail - Parkerford Parking & Trailhead",
      "poi_type": "Transportation",
      "poi_address": "320 Linfield Rd, Pottstown, PA 19475, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-b43b-7748-8b8a-ccb1c414c3ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-b43b-7748-8b8a-ccb1c414c3ea",
        "storage_key": "property/6767906449166316/019fcdf6-b43b-7748-8b8a-ccb1c414c3ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://schuylkillriver.org/map/trailhead/parkerford-access/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2437815378250830476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schuylkill-river-trail---parkerford-parking--trailhead",
      "poi_latitude": "40.20062650000001",
      "poi_longitude": "-75.5838474",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2789-737a-81f6-f20a9b173183",
        "storage_key": "property/6767906449166316/019d0266-2789-737a-81f6-f20a9b173183.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJeS5nE_aPxokRjBKgoCvc1CE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d0495760-44e7-48b2-9c92-47e807cd90c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Limerick Generating Station",
      "poi_type": "Major Employers",
      "poi_address": "3146 Sanatoga Rd, Pottstown, PA 19464, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-b472-71c4-b419-ce93e9edbf50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-b472-71c4-b419-ce93e9edbf50",
        "storage_key": "property/6767906449166316/019fcdf6-b472-71c4-b419-ce93e9edbf50.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.constellationenergy.com/our-company/locations/location-sites/limerick-generating-station.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5669029525810450589&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "limerick-generating-station",
      "poi_latitude": "40.2254586",
      "poi_longitude": "-75.5858582",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-483-3220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2c8c-7375-839d-b6c5561e24b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2c8c-7375-839d-b6c5561e24b7",
        "storage_key": "property/6767906449166316/019d0266-2c8c-7375-839d-b6c5561e24b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpawrzZ-FxokRnRAiY1FwrE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_84462e76-6ea6-4827-b43f-b3896790e996",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "SEI Investments",
      "poi_type": "Major Employers",
      "poi_address": "1 Freedom Valley Dr, Oaks, PA 19456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-ba87-75bd-b1cb-559bcb3f7ade.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-ba87-75bd-b1cb-559bcb3f7ade",
        "storage_key": "property/6767906449166316/019fcdf6-ba87-75bd-b1cb-559bcb3f7ade.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8252600329308828774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sei-investments",
      "poi_latitude": "40.1441913",
      "poi_longitude": "-75.44826239999999",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-342-5734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ76AFIDqRxokRZnS5fUYgh3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e36c84dc-360c-485c-a6f4-3e80b5fd12f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "UNISYS",
      "poi_type": "Major Employers",
      "poi_address": "801 Lakeview Dr, Blue Bell, PA 19422, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-b9db-7461-a454-ea728c9c5fae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-b9db-7461-a454-ea728c9c5fae",
        "storage_key": "property/6767906449166316/019fcdf6-b9db-7461-a454-ea728c9c5fae.webp",
        "width": 1280,
        "height": 934
      },
      "poi_business_url": "http://www.unisys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8469326812483350148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unisys",
      "poi_latitude": "40.1416877",
      "poi_longitude": "-75.2869704",
      "poi_miles_from_property": "17.0 mi",
      "poi_walking_minutes": "6 hours 17 mins",
      "poi_biking_minutes": "2 hours 13 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 215-986-4011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK70kqfu8xokRhO7CEN0XiXU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_52f6429b-01bb-4deb-bc32-dc9c263feb68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Pfizer",
      "poi_type": "Major Employers",
      "poi_address": "500 Arcola Rd, Collegeville, PA 19426, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-baf7-72f8-b27f-65c6f4912152.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-baf7-72f8-b27f-65c6f4912152",
        "storage_key": "property/6767906449166316/019fcdf6-baf7-72f8-b27f-65c6f4912152.webp",
        "width": 1019,
        "height": 1280
      },
      "poi_business_url": "https://www.pfizer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14249068411934818514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pfizer",
      "poi_latitude": "40.1635928",
      "poi_longitude": "-75.4669309",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 484-865-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVS8ZtOOQxokR0kCd0TncvsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_85244430-2c22-46a4-99f1-7967ca3f3ccb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Ursinus College",
      "poi_type": "Major Employers",
      "poi_address": "601 E Main St, Collegeville, PA 19426, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-bb27-7652-82fd-543aa2a4600a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-bb27-7652-82fd-543aa2a4600a",
        "storage_key": "property/6767906449166316/019fcdf6-bb27-7652-82fd-543aa2a4600a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ursinus.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15686580551458727593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ursinus-college",
      "poi_latitude": "40.19396769999999",
      "poi_longitude": "-75.4563232",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 610-409-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-22b1-731b-8319-173855e6967a",
        "storage_key": "property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWawyy6GQxokRqaY_hubtsdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e6d47d91-5992-4e38-a366-d51d3ff2bf39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Montgomery County Community College",
      "poi_type": "Major Employers",
      "poi_address": "340 Dekalb Pike, Blue Bell, PA 19422, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-c0a1-745b-8013-c5b399dc251a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-c0a1-745b-8013-c5b399dc251a",
        "storage_key": "property/6767906449166316/019fcdf6-c0a1-745b-8013-c5b399dc251a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mc3.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2943399387633382788&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montgomery-county-community-college",
      "poi_latitude": "40.1765166",
      "poi_longitude": "-75.276761",
      "poi_miles_from_property": "17.9 mi",
      "poi_walking_minutes": "6 hours 34 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 215-641-6551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-22b1-731b-8319-173855e6967a",
        "storage_key": "property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_4z7XzOjxokRhHX98yUO2Sg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_faae52c5-6a1a-4e94-bbbc-bdc58c4ffecd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Montgomery County Community College: Pottstown Campus",
      "poi_type": "Major Employers",
      "poi_address": "101 College Dr, Pottstown, PA 19464, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-c193-716b-8b31-2ddc9b02f23f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-c193-716b-8b31-2ddc9b02f23f",
        "storage_key": "property/6767906449166316/019fcdf6-c193-716b-8b31-2ddc9b02f23f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.mc3.edu",
      "poi_directions_map_url": "https://maps.google.com/?cid=2754466177562818981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montgomery-county-community-college-pottstown-campus",
      "poi_latitude": "40.2452964",
      "poi_longitude": "-75.65616600000001",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 610-718-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-22b1-731b-8319-173855e6967a",
        "storage_key": "property/6767906449166316/019d0266-22b1-731b-8319-173855e6967a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu4fPmEeGxokRpbl1C2XUOSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_976229d7-4791-47cc-9f0e-57461b200207",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Pottstown Hospital",
      "poi_type": "Major Employers",
      "poi_address": "1600 E High St, Pottstown, PA 19464, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-89fd-709a-92f9-dce71b668415.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-89fd-709a-92f9-dce71b668415",
        "storage_key": "property/6767906449166316/019fcdf6-89fd-709a-92f9-dce71b668415.webp",
        "width": 750,
        "height": 750
      },
      "poi_business_url": "https://towerhealth.org/locations/pottstown-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=10594659352548128736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pottstown-hospital",
      "poi_latitude": "40.2426719",
      "poi_longitude": "-75.6121704",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-327-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cc8-762b-99ae-bf3b0f29f967",
        "storage_key": "property/6767906449166316/019d0266-1cc8-762b-99ae-bf3b0f29f967.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5cvWC1GGxokR4LfmWIzKB5M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b1a8206f-60a0-48b2-a788-5e1257e1b010",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "Phoenixville Hospital",
      "poi_type": "Major Employers",
      "poi_address": "140 Nutt Rd, Phoenixville, PA 19460, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fcdf6-c068-779c-98ac-8a49d256126c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf6-c068-779c-98ac-8a49d256126c",
        "storage_key": "property/6767906449166316/019fcdf6-c068-779c-98ac-8a49d256126c.webp",
        "width": 630,
        "height": 630
      },
      "poi_business_url": "https://towerhealth.org/locations/phoenixville-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=10346396596746036200&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phoenixville-hospital",
      "poi_latitude": "40.123546",
      "poi_longitude": "-75.5150099",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 610-983-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-30ca-729f-8098-fb0ab2ad19c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-30ca-729f-8098-fb0ab2ad19c6",
        "storage_key": "property/6767906449166316/019d0266-30ca-729f-8098-fb0ab2ad19c6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ19jZOB2SxokR6KNbHuPIlY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d7178d8e-066f-4ab4-938e-10102c4e894a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "poi_name": "The Pennsylvania Department of Corrections",
      "poi_type": "Major Employers",
      "poi_address": "4533 W Schwenksville, Schwenksville, PA 19473, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.cor.pa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15459139137749574474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-pennsylvania-department-of-corrections",
      "poi_latitude": "40.2308311",
      "poi_longitude": "-75.41959750000001",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 610-489-4151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019d0266-2c8c-7375-839d-b6c5561e24b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2c8c-7375-839d-b6c5561e24b7",
        "storage_key": "property/6767906449166316/019d0266-2c8c-7375-839d-b6c5561e24b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6S1KAb69xokRSuPmxiPlidY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_f6344b23-9951-4cfa-a0c9-8cc52d567972",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_4952df26-cbe8-423e-940c-1b22ca999663",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_246bd72a-d9b2-4e13-879b-7e12a0e2e93b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_fe352e66-af41-4e70-a28a-a554b5893a87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b974e3fe-1fd2-4a0d-b4cb-17b398869866",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_91589944-1ded-4fe1-ba48-04a8cbb046d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_bf6da3b4fcc96f7e7224473e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "rating": "5",
      "name": "Justin Howell",
      "text": "My girlfriend lives here, and since the new management took over, they actually communicate and fix things! Things are really looking up. She was planning to move but decided to stay. It’s a beautiful property that’s well-maintained, with a great office staff!",
      "date": "2025-10-23",
      "title": "false"
    },
    {
      "id": "ec_d2892ee9da8bd4d95e3fd6e3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "rating": "5",
      "name": "Kevin Lambert",
      "text": "I want to share my terrific experience with the management team at Fox Ridge working through a recent issue. They were amazing in their professionalism, accommodating demeanor and overall support. This has been an outstanding experience for my mom who has lived here for over ten years.",
      "date": "2025-10-09",
      "title": "false"
    },
    {
      "id": "ec_58d60027c79993e5d6096974",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "rating": "5",
      "name": "Robert Brown",
      "text": "We recently moved to Fox Ridge and are very happy with the community but we were disappointed  with the previous  management  team. . They were unresponsive to all our service request. Thank God Aion  is now the owners.  Our dryer stopped heating up. Made a call and within a day we had a replacement dryer in place. Michael the maintence man was professional, courteous  and friendly. Great job Michael.. .Made several other request  to the new property manager and she was at my apartment the same day.. Great job.. looking for to living here for along time.",
      "date": "2025-09-04",
      "title": "false"
    },
    {
      "id": "ec_6e62b4a09cfaf501c4a693e8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "rating": "5",
      "name": "Samira W",
      "text": "I took a tour of the property and everyone was so welcoming helpful. It looked so well-maintained. I hope to rent some time next summer, especially because I’ve never had that level of customer service in a really long time.",
      "date": "2025-10-24",
      "title": "false"
    },
    {
      "id": "ec_e29a783992f02e39053a2205",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "rating": "5",
      "name": "Jennifer Umstead",
      "text": "The location is great! Close to everything but still set back from the major highway. The grounds are clean and neat. The new staff is professional and helpful.",
      "date": "2025-10-23",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_168356ef-bdd6-409f-ac76-1d114c919f48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/019fa44d-45e7-7569-8058-2af25fcf3b5e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fa44d-45e7-7569-8058-2af25fcf3b5e",
        "storage_key": "property/6767906449166316/019fa44d-45e7-7569-8058-2af25fcf3b5e.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Fox Ridge",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=690ac0bec5e1f99c670fca85&sourceId=1001"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_e68bb94b45c2ecab941d8ff1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "452730",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e9da8b22effb72949b670acb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "452731",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_b66b947ce6babf532bf96977",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "452732",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "50.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fa7354ac8b2a82ea7cc7e5a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "452734",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_12368f913eb59ce6a581d6fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "452736",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1eaf3be1b405d21c741767c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "452738",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c7679970a68a284a2677bba0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "536750",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.66,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_7e0a33067e4576c92ecf9dca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "536751",
      "name": "Trash Service",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_7f05eb10ff3335605a073e79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "543107",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_eb90b86418ded513b36fd15f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "543110",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a894db5f6f7fb72ffa2a1919",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "543111",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_81b49059a41351dcd48b555f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "835243",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_5703a76457c13ef4913aefa6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "835251",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_403216414d369f19ac1404fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "835252",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8f63c135059b06255adc321e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "835254",
      "name": "Admin Fee",
      "description": "Assessed per occurrence for any modification to the Lease Agreement, including but not limited to the addition, removal, or substitution of any leaseholder or occupant.",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_aa7a577d1db367c2047b7042",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "835255",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4ea90bbbf1905639f6c85d86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "838628",
      "name": "Parking - Reserved/Covered",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_046bd8d7733ea91434bce6a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "838638",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_bb84f98fe3761575ca7a0235",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "engrain",
      "external_id": "838644",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a12f7-f601-7409-a054-1399b9a60af8",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-fox-ridge-apartments-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316"
    },
    {
      "lead_collector_id": "019c3043-4abb-735e-8760-6754ea4004c3",
      "lead_source": "FACEBOOK_ADS",
      "name": "fox-ridge",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316"
    },
    {
      "lead_collector_id": "019c3043-4b2c-75ce-8053-31962a1e2a48",
      "lead_source": "LANDING_PAGE",
      "name": "fox-ridge",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "apartments-with-in-unit-laundry-limerick-and-royersford-pa-70",
      "search_query": "apartments with in-unit laundry Limerick and Royersford PA",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Limerick and Royersford, PA",
      "h2_subtitle": "Discover convenient living with in-unit laundry at Fox Ridge & Lakeview Park Apartments. Located in Limerick and Royersford, PA, enjoy a hassle-free lifestyle today.",
      "page_copy": "Experience the ultimate convenience with apartments featuring in-unit laundry at Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA. Nestled in the serene environment of Limerick and Royersford, our spacious one and two-bedroom floor plans offer the perfect blend of style and practicality. Alongside the full-size washer and dryer, residents enjoy modern amenities such as a fitness center, tennis court, and gorgeous pond views reflecting peace and beauty right outside your door.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fox Ridge & Lakeview Park Apartments: In-Unit Laundry Apartments Limerick and Royersford, PA",
      "seo_description": "Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA, offers in-unit laundry, spacious plans, and modern amenities. Discover effortless living today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-montgomery-county-673",
      "search_query": "pet friendly apartments Montgomery County",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Montgomery County",
      "h2_subtitle": "Fox Ridge & Lakeview Park Apartments offers pet-friendly living in Montgomery County. Enjoy the perfect home for you and your furry friends.",
      "page_copy": "Fox Ridge & Lakeview Park Apartments champion comfortable, pet-friendly living with premium fixtures like black fittings, tile backsplash, and microwaves, ensuring modern aesthetics throughout. The addition of in-unit laundry not only meets the demands of busy lifestyles but also enhances the living experience, providing the freedom and flexibility you deserve. Visit us in Montgomery County today and let Fox Ridge & Lakeview Park Apartments be your ideal home with the conveniences you desire.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fox Ridge & Lakeview Park Apartments: Pet Friendly Apts Montgomery County",
      "seo_description": "Fox Ridge & Lakeview Park Apartments in Montgomery County offers pet-friendly living with modern amenities. Find your perfect home for you and your pet today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "fox-ridge-and-lakeview-park-apartments-fitness-center-604",
      "search_query": "Fox Ridge & Lakeview Park Apartments fitness center apartments",
      "category": "Amenity",
      "h1_title": "Fox Ridge & Lakeview Park Apartments with Fitness Center",
      "h2_subtitle": "Stay active at Fox Ridge & Lakeview Park Apartments, featuring a full fitness center. Enjoy a health-focused lifestyle in Limerick and Royersford, PA.",
      "page_copy": "Welcome to Fox Ridge & Lakeview Park Apartments, the ideal pet-friendly living option in Montgomery County. Nestled in the welcoming community of Limerick and Royersford, PA, Fox Ridge & Lakeview Park Apartments ensures that both you and your furry companions feel right at home. Choose from spacious one and two-bedroom layouts that provide plenty of room for everyone, including your pets.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fox Ridge & Lakeview Park Apartments: Apartments with Fitness Center",
      "seo_description": "Enjoy fitness-focused living at Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA. Featuring a full fitness center, spacious living, and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-near-19468-990",
      "search_query": "air conditioned apartments near 19468",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near 19468",
      "h2_subtitle": "Stay cool at Fox Ridge & Lakeview Park Apartments near 19468, offering air-conditioned homes for a comfortable living experience.",
      "page_copy": "Our community is designed with features that cater to pet owners, combining modern amenities with comfort and style. Enjoy amenities such as a fitness center, tennis court, and pet-friendly spaces that make life easier and more enjoyable. Come embrace the serene lifestyle with pond views and thoughtful details like tile backsplash and black fixtures, all while having your beloved pet by your side. Visit Fox Ridge & Lakeview Park Apartments and find the pet-friendly home you’ve always dreamed of.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fox Ridge & Lakeview Park Apartments: Air Conditioned Apartments Near 19468",
      "seo_description": "Fox Ridge & Lakeview Park Apartments near 19468 offer air-conditioned living with spacious layouts and modern amenities. Enjoy comfort and convenience today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "apartments-with-dishwasher-limerick-and-royersford-pa-27",
      "search_query": "apartments with dishwasher Limerick and Royersford",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwashers in Limerick and Royersford",
      "h2_subtitle": "Discover the convenience of having a dishwasher in your apartment at Fox Ridge & Lakeview Park Apartments in Limerick and Royersford. Enjoy hassle-free living today!",
      "page_copy": "Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA, offers residents a comprehensive lifestyle package, including a state-of-the-art fitness center. Positioned in the heart of Montgomery County, our community provides spacious one and two-bedroom apartments perfect for those who value both comfort and fitness in their daily routine.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fox Ridge & Lakeview Park Apartments: Limerick and Royersford, PA Apartments with Dishwashers",
      "seo_description": "Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA offer modern living with the convenience of dishwashers and other amenities. Discover your new home today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-limerick-and-royersford-pa-522",
      "search_query": "one bedroom apartments Limerick and Royersford PA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Limerick and Royersford, PA",
      "h2_subtitle": "Explore spacious one-bedroom apartments at Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA. Perfectly designed for modern living and comfort.",
      "page_copy": "The fitness center at Fox Ridge & Lakeview Park Apartments is equipped with everything you need for a complete workout, whether you're starting your day with a cardio session or winding down with some strength training. Apart from the fitness amenities, residents can also enjoy a tennis court and the peaceful surroundings with scenic pond views. Combine health, relaxation, and style at Fox Ridge & Lakeview Park Apartments — your destination for modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Limerick and Royersford, PA | Fox Ridge & Lakeview Park Apartments",
      "seo_description": "Discover one-bedroom apartments in Limerick and Royersford, PA at Fox Ridge & Lakeview Park Apartments. Spacious layouts with modern amenities await you. Schedule a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-montgomery-county-805",
      "search_query": "two bedroom apartments Montgomery County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Montgomery County",
      "h2_subtitle": "Find spacious two-bedroom apartments at Fox Ridge & Lakeview Park Apartments, located in Montgomery County. Perfect for modern and convenient living.",
      "page_copy": "Experience the comfort of air-conditioned living at Fox Ridge & Lakeview Park Apartments, conveniently located near the 19468 area in Limerick and Royersford, PA. Our community provides a refreshing environment, complemented by modern amenities and spacious one and two-bedroom floor plans, perfect for beating the heat during warm summer days.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Montgomery County | Fox Ridge & Lakeview Park Apartments",
      "seo_description": "Explore two-bedroom apartments in Montgomery County at Fox Ridge & Lakeview Park Apartments. Enjoy modern amenities and spacious living. Schedule your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "apartments-near-limerick-elementary-school-pa-124",
      "search_query": "apartments near Limerick Elementary School",
      "category": "School",
      "h1_title": "Apartments Near Limerick Elementary School",
      "h2_subtitle": "Discover Fox Ridge & Lakeview Park Apartments, conveniently located near Limerick Elementary School in PA. Enjoy comfort and convenience for the whole family.",
      "page_copy": "At Fox Ridge & Lakeview Park Apartments, residents benefit from the convenience of air conditioning paired with community features like a fitness center and a tennis court, ensuring a balanced lifestyle. Enjoy contemporary living with full-size washer and dryer units, microwaves, and stylish interiors featuring tile backsplash and black fixtures. With serene pond views and pet-friendly options, Fox Ridge & Lakeview Park Apartments is the ultimate choice for comfortable air-conditioned living in Montgomery County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Limerick Elementary School | Fox Ridge & Lakeview Park Apartments",
      "seo_description": "Find apartments near Limerick Elementary School at Fox Ridge & Lakeview Park Apartments. Ideal for families seeking a convenient and modern living option. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "apartments-close-to-brooke-elementary-school-limerick-775",
      "search_query": "apartments close to Brooke Elementary School Limerick and Royersford",
      "category": "School",
      "h1_title": "Apartments Close to Brooke Elementary School",
      "h2_subtitle": "Live conveniently at Fox Ridge & Lakeview Park Apartments, close to Brooke Elementary School in Limerick and Royersford. Perfect for families who value easy access to schools.",
      "page_copy": "Welcome to Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA, where convenience meets modern living. Our community offers one and two-bedroom apartments equipped with a dishwasher, ensuring your everyday tasks are as simple as possible. Enjoy the pleasure of hassle-free kitchen clean-ups while you spend more time on what truly matters.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Brooke Elementary School | Fox Ridge & Lakeview Park Apartments",
      "seo_description": "Discover apartments close to Brooke Elementary School in Limerick and Royersford, PA at Fox Ridge & Lakeview Park Apartments. Offering modern conveniences for families. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "evans-elementary-school-apartments-montgomery-county-698",
      "search_query": "Evans Elementary School apartments Montgomery County",
      "category": "School",
      "h1_title": "Evans Elementary School Apartments",
      "h2_subtitle": "Fox Ridge & Lakeview Park Apartments in Montgomery County offers family-friendly living near Evans Elementary School. Experience comfortable and convenient home life.",
      "page_copy": "Located in the heart of Limerick and Royersford, Fox Ridge & Lakeview Park Apartments blends practical amenities with stylish features, including full-size washers and dryers, microwaves, and chic tile backsplashes. Whether you’re relaxing by the serene pond views or breaking a sweat in the fitness center, experience all the benefits of modern living here. Schedule a visit and discover how our dishwashers and other amenities make life at Fox Ridge & Lakeview Park Apartments effortless.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Evans Elementary School Apartments | Fox Ridge & Lakeview Park Apartments",
      "seo_description": "Find your ideal family home near Evans Elementary School in Montgomery County at Fox Ridge & Lakeview Park Apartments. Modern living and amenities await!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "spring-ford-middle-school-grade-center-apartments-228",
      "search_query": "Spring-Ford Middle School 5/6/7 Grade Center nearby apartments",
      "category": "School",
      "h1_title": "Apartments Near Spring-Ford Middle School",
      "h2_subtitle": "Discover convenient living at Fox Ridge & Lakeview Park Apartments, located near Spring-Ford Middle School 5/6/7 Grade Center. Ideal for families in search of modern comfort.",
      "page_copy": "Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA, offers beautifully designed one-bedroom apartments perfect for those seeking a blend of style and convenience. Each layout is thoughtfully curated to provide ample space, ensuring you have the perfect environment to relax and unwind.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spring-Ford Middle School Apartments | Fox Ridge & Lakeview Park Apartments",
      "seo_description": "Explore Fox Ridge & Lakeview Park Apartments near Spring-Ford Middle School 5/6/7 Grade Center. Perfect for families seeking comfort and convenience. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "apartments-near-spring-ford-middle-school-8th-grade-center-483",
      "search_query": "apartments near Spring-Ford Middle School 8th Grade Center",
      "category": "School",
      "h1_title": "Apartments Near Spring-Ford 8th Grade Center",
      "h2_subtitle": "Live close to Spring-Ford Middle School 8th Grade Center at Fox Ridge & Lakeview Park Apartments. Perfect for families seeking convenience and comfort in Limerick and Royersford.",
      "page_copy": "Nestled in Montgomery County, Fox Ridge & Lakeview Park Apartments boasts modern amenities such as a fitness center, a tennis court, and in-home full-size washers and dryers. The contemporary interiors feature stylish tile backsplashes, and sleek black fixtures, elevating your living experience. Enjoy the tranquility of serene pond views while being close to everything Limerick and Royersford have to offer. Embrace comfort and style at Fox Ridge & Lakeview Park Apartments' one-bedroom apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Spring-Ford 8th Grade Center | Fox Ridge & Lakeview Park Apartments",
      "seo_description": "Find welcoming apartments near Spring-Ford Middle School 8th Grade Center at Fox Ridge & Lakeview Park Apartments. Discover comfort and convenience. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "spring-ford-area-high-school-apartments-limerick-and-royersford-172",
      "search_query": "Spring-Ford Area High School 10-12 Grade Center apartments Limerick and Royersford",
      "category": "School",
      "h1_title": "Apartments Near Spring-Ford High School",
      "h2_subtitle": "Fox Ridge & Lakeview Park Apartments in Limerick and Royersford offers ideal living near Spring-Ford Area High School 10-12 Grade Center. Enjoy convenience and modern amenities.",
      "page_copy": "Fox Ridge & Lakeview Park Apartments invites you to explore our spacious two-bedroom apartments located in the heart of Montgomery County. Designed to cater to your modern lifestyle, our floor plans offer ample living space, perfect for families and individuals seeking comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spring-Ford High School Apartments | Fox Ridge & Lakeview Park Apartments",
      "seo_description": "Discover Fox Ridge & Lakeview Park Apartments near Spring-Ford Area High School 10-12 Grade Center in Limerick and Royersford, PA. Modern amenities and convenience await. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "fox-ridge-and-lakeview-apartments-near-limerick-and-royersford-community-park-923",
      "search_query": "Fox Ridge & Lakeview Park Apartments near Limerick Community Park",
      "category": "Park",
      "h1_title": "Fox Ridge & Lakeview Park Apartments Near Limerick Park",
      "h2_subtitle": "Enjoy life at Fox Ridge & Lakeview Park Apartments, conveniently located near Limerick Community Park. Perfect for outdoor enthusiasts seeking comfort and accessibility.",
      "page_copy": "Our community boasts a wide array of amenities including a fully-equipped fitness center, tennis court, and serene pond views, ensuring you have plenty of opportunities to relax and enjoy. Each apartment features contemporary touches such as tile backsplashes, full-size washers and dryers, and a microwave, enhancing both functionality and aesthetics. Experience the best of Montgomery County living at Fox Ridge & Lakeview Park Apartments, where spacious two-bedroom homes await you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fox Ridge & Lakeview Park Apartments by Limerick and Royersford Park",
      "seo_description": "Live at Fox Ridge & Lakeview Park Apartments near Limerick and Royersford Community Park. Enjoy modern living with easy park access. Perfect for nature lovers. Schedule a tour!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "apartments-close-to-linfield-sports-park-limerick-and-royersford-374",
      "search_query": "apartments close to Linfield Sports Park Limerick and Royersford",
      "category": "Park",
      "h1_title": "Apartments Near Linfield Sports Park",
      "h2_subtitle": "Fox Ridge & Lakeview Park Apartments in Limerick and Royersford offers proximity to Linfield Sports Park. It's an ideal spot for sports enthusiasts and active families.",
      "page_copy": "Welcome to Fox Ridge & Lakeview Park Apartments, ideally situated for families with children attending Limerick Elementary School in PA. Our community offers a selection of spacious one and two-bedroom apartments, providing a comfortable and convenient lifestyle close to educational facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Linfield Sports Park | Fox Ridge & Lakeview Park Apartments",
      "seo_description": "Discover modern living at Fox Ridge & Lakeview Park Apartments near Linfield Sports Park in Limerick and Royersford, PA. Perfect for active lifestyles. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "trinley-park-proximity-apartments-limerick-and-royersford-pa-231",
      "search_query": "Trinley Park proximity apartments Limerick and Royersford PA",
      "category": "Park",
      "h1_title": "Apartments Near Trinley Park, Limerick and Royersford, PA",
      "h2_subtitle": "Nestled near Trinley Park, Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA, offers a blend of convenience and modern living amenities.",
      "page_copy": "Located in a family-friendly environment, Fox Ridge & Lakeview Park Apartments seamlessly combines modern amenities with a welcoming atmosphere. Residents enjoy access to a fitness center, tennis court, and full-size washers and dryers in each apartment. The convenient location adds ease to family routines, ensuring that the school run is quick and hassle-free. Discover the perfect balance of comfort and practicality at Fox Ridge & Lakeview Park Apartments, your ideal home near Limerick Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Trinley Park | Fox Ridge & Lakeview Park Apartments Limerick and Royersford PA",
      "seo_description": "Find your perfect home at Fox Ridge & Lakeview Park Apartments near Trinley Park, Limerick and Royersford PA. Enjoy modern amenities and a park-side lifestyle. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "kurylo-preserve-nearby-apartments-limerick-and-royersford-508",
      "search_query": "Kurylo Preserve nearby apartments Limerick and Royersford",
      "category": "Park",
      "h1_title": "Apartments Near Kurylo Preserve, Limerick and Royersford",
      "h2_subtitle": "Fox Ridge & Lakeview Park Apartments offer a prime location close to Kurylo Preserve in Limerick and Royersford. Explore nature trails and enjoy convenient living.",
      "page_copy": "Fox Ridge & Lakeview Park Apartments offers an ideal living solution for families seeking convenience with its close proximity to Brooke Elementary School in Limerick and Royersford. Our spacious one and two-bedroom apartments are designed to provide comfort and practicality, making daily school commutes a breeze.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kurylo Preserve | Fox Ridge & Lakeview Park Apartments Limerick",
      "seo_description": "Explore Fox Ridge & Lakeview Park Apartments near Kurylo Preserve in Limerick and Royersford, PA. Enjoy modern amenities and the tranquility of nature. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "apartments-near-stone-hills-preserve-montgomery-county-483",
      "search_query": "apartments near Stone Hills Preserve Montgomery County",
      "category": "Park",
      "h1_title": "Apartments Near Stone Hills Preserve",
      "h2_subtitle": "Live near Stone Hills Preserve at Fox Ridge & Lakeview Park Apartments, located in Montgomery County. Enjoy natural beauty and modern comforts.",
      "page_copy": "Enjoy a range of amenities within our community, including a tennis court, fitness center, and serene pond views. Each apartment is equipped with modern features like full-size washers and dryers, stylish tile backsplashes, and black fixtures. Families will appreciate the blend of modern convenience and a welcoming environment. Choose Fox Ridge & Lakeview Park Apartments for an inspiring place to call home near Brooke Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Stone Hills Preserve | Fox Ridge & Lakeview Park Apartments",
      "seo_description": "Discover Fox Ridge & Lakeview Park Apartments near Stone Hills Preserve in Montgomery County. Enjoy modern living with nature's beauty nearby. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "fox-ridge-and-lakeview-apartments-near-royersford-riverfront-park-558",
      "search_query": "Fox Ridge & Lakeview Park Apartments near Royersford Riverfront Park",
      "category": "Park",
      "h1_title": "Fox Ridge & Lakeview Park Apartments Near Royersford Park",
      "h2_subtitle": "Located near Royersford Riverfront Park, Fox Ridge & Lakeview Park Apartments offers a blend of nature and modern amenities in Limerick and Royersford, PA.",
      "page_copy": "Fox Ridge & Lakeview Park Apartments provides an exceptional living experience for those looking to reside near Evans Elementary School in Montgomery County. Our community caters to families, offering spacious one and two-bedroom floor plans equipped with modern amenities, ensuring convenience and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fox Ridge & Lakeview Park Apartments Apts Near Royersford Riverfront Park",
      "seo_description": "Find your ideal home at Fox Ridge & Lakeview Park Apartments near Royersford Riverfront Park in Limerick and Royersford, PA. Enjoy modern amenities and riverside living. Schedule a tour!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "limerick-and-royersford-pa-apartments-near-lock-60-recreation-area-716",
      "search_query": "Limerick and Royersford PA apartments near Lock 60 Recreation Area",
      "category": "Park",
      "h1_title": "Limerick and Royersford Apartments Near Lock 60 Recreation",
      "h2_subtitle": "Fox Ridge & Lakeview Park Apartments in Limerick and Royersford, PA offers convenient access to the Lock 60 Recreation Area, blending adventure with modern comforts.",
      "page_copy": "In addition to a location that simplifies school commutes, Fox Ridge & Lakeview Park Apartments offers a fitness center, tennis court, and scenic pond views. Each apartment features contemporary touches like tile backsplashes, a full-size washer and dryer, and black fixtures. Discover how Fox Ridge & Lakeview Park Apartments can enhance your family’s lifestyle with modern comforts within reach of Evans Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Limerick and Royersford PA Apts Near Lock 60 Recreation Area",
      "seo_description": "Discover Fox Ridge & Lakeview Park Apartments near Lock 60 Recreation Area in Limerick and Royersford, PA. Enjoy modern living and outdoor activities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "apartments-close-to-black-rock-sanctuary-pa-452",
      "search_query": "apartments close to Black Rock Sanctuary PA",
      "category": "Park",
      "h1_title": "Apartments Near Black Rock Sanctuary",
      "h2_subtitle": "Discover Fox Ridge & Lakeview Park Apartments, conveniently located near Black Rock Sanctuary in PA. Enjoy nature at your doorstep with modern comforts.",
      "page_copy": "Fox Ridge & Lakeview Park Apartments offers a perfect blend of convenience and modern living, especially for families with students attending Spring-Ford Middle School 5/6/7 Grade Center. Our community's location in Montgomery County provides easy access to educational facilities, suited for families prioritizing proximity to school.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Black Rock Sanctuary PA | Fox Ridge & Lakeview Park Apartments",
      "seo_description": "Live at Fox Ridge & Lakeview Park Apartments near Black Rock Sanctuary, PA. Enjoy modern amenities and nature’s beauty. Schedule a visit to our community!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166316",
      "source": "custom",
      "page_item_url": "apartments-near-philadelphia-international-airport-pa-912",
      "search_query": "apartments near Philadelphia International Airport PA",
      "category": "Transit",
      "h1_title": "Apartments Near Philadelphia Int'l Airport",
      "h2_subtitle": "Fox Ridge & Lakeview Park Apartments, located conveniently near Philadelphia International Airport, PA, offers easy access to travel and city life.",
      "page_copy": "Enjoy spacious one and two-bedroom layouts featuring amenities like a fitness center, tennis court, and in-unit full-size washers and dryers. Each apartment at Fox Ridge & Lakeview Park Apartments comes with stylish tile backsplashes and black fixtures, offering a contemporary living space. With serene pond views and a child-friendly atmosphere, our community is designed to enhance family life, providing an ideal setting near Spring-Ford Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
      "featured_image_media": {
        "alt_text": "Apartment buildings reflected in a calm pond surrounded by trees.",
        "public_id": "01a015d9-d559-70cc-9c7e-dc9ad08d8f9a",
        "storage_key": "property/6767906449166316/01a015d9-d559-70cc-9c7e-dc9ad08d8f9a.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Philadelphia Int'l Airport | Fox Ridge & Lakeview Park Apartments",
      "seo_description": "Choose Fox Ridge & Lakeview Park Apartments near Philadelphia International Airport, PA, for modern living with easy travel access. Tour our community today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5054"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976242268"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5515381"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TZ96FCM2"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://liveatfoxridge.fatwin.com/api/websites/resources/1?x=VHIzK1JHbldUcFRVVjN6SDdNekxGdFNCYmlBNlk3cGFtR3Y3MWJrVlp2ZGJmTlZhT1JiQnlOUTFrVmxFNExYZktIbWorK0xjNFR5aXJacFI5OUUwYnc9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "53176767895"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8epm5y46w6d"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "a37ddc16-56ee-11f0-93db-bf11cc7238ce"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/a37ddc16-56ee-11f0-93db-bf11cc7238ce/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/a37ddc16-56ee-11f0-93db-bf11cc7238ce/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlJGQ1M3azJlWHI5MUtrOE40WDJ4QlE9PSIsInZhbHVlIjoib2k4NEkwRmNMQmNyY3VXUHVJb2JXUT09IiwibWFjIjoiYTE3MzRiMTkzNDhjMzc4NTExODMxYjAwMTQ0MTMyNzc3MGNlZTE1NmRiNDJhMzcxYzhhYmQzNmIyYWM1ZWEyOCJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5054",
  "custom_repli_id": "9976242268",
  "custom_realpage_id": "5515381",
  "custom_google_gtm_id": "GTM-TZ96FCM2",
  "custom_perq_script_url": "https://liveatfoxridge.fatwin.com/api/websites/resources/1?x=VHIzK1JHbldUcFRVVjN6SDdNekxGdFNCYmlBNlk3cGFtR3Y3MWJrVlp2ZGJmTlZhT1JiQnlOUTFrVmxFNExYZktIbWorK0xjNFR5aXJacFI5OUUwYnc9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "53176767895",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/8epm5y46w6d",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "a37ddc16-56ee-11f0-93db-bf11cc7238ce",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/a37ddc16-56ee-11f0-93db-bf11cc7238ce/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/a37ddc16-56ee-11f0-93db-bf11cc7238ce/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlJGQ1M3azJlWHI5MUtrOE40WDJ4QlE9PSIsInZhbHVlIjoib2k4NEkwRmNMQmNyY3VXUHVJb2JXUT09IiwibWFjIjoiYTE3MzRiMTkzNDhjMzc4NTExODMxYjAwMTQ0MTMyNzc3MGNlZTE1NmRiNDJhMzcxYzhhYmQzNmIyYWM1ZWEyOCJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "179a2fed-83c8-47ec-b603-772553670911",
  "custom_audioeye_site_hash": "01ad15dc8304f73d162ab6c7f06bee68"
};

export const generatedAt = '2026-10-22T20:07:03.439Z';
